//English  提示：只需要翻译冒号:后面的英文即可。
export const language = {
    //2020-10-26-ljm增加
    meassage:{
        leanMore:'Saber mais',
        skip:'Pular',
        activate:'Ativar',
        emailSend: 'Email sent!',
        },
    leftBanner: {
        liteFile: 'Lite File',
        logoSlogan: 'Top em transferência na nuvem',
        cloudEscription: 'MultCloud – A escolha ideal para transferência de dados de nuvem para nuvem',
        commonTools: 'Ferramentas comuns',
        cloudDrives: 'Minha unidade',
        onlineServices: 'Meus serviços online',
        switchTxt: 'MultCloud clássico',
        taskList: 'Lista de tarefas',
        cloudTransfer: 'Transferência na nuvem',
        cloudSync: 'Sincronização em nuvem',
        cloudBackup:'Backup de nuvem',
        btLink: 'Upload Remoto',
        teamTransfer:'Transferência de equipe',
        shares: 'Acções',
        emailTransfer: 'Migração de e-mail',
        instagramDownload: 'Instagram Downloader',
        videoDownload: 'Baixador de Vídeos',
        webDownload: 'Baixador de imagens',
        addCloud: 'Add Cloud',
        addEmail: 'Add Email',
        encryption: 'criptografia',
        edit: 'Adicionar novamente',
        remove: 'Retirar',
        createTask: 'Criar tarefa',
        createTaskText: 'Você pode criar as tarefas mais comuns aqui.',
        gotIt: 'Entendi',
        bigWriteEncrypt: 'Criptografia',
        encryptionText: 'Você pode configurar a criptografia de arquivos na nuvem aqui.',
        addCloudText: 'Clique aqui para conectar seu drive em nuvem e e-mail ao MultCloud.',
        inviteFriends: 'Convide Amigos',
        switchTip:'Mude para Classic MultCloud',
        switchTipDes:' Você pode alternar para o MultCloud clássico aqui.',
        new: 'Novo',
    },
    common: {
        addCloud: 'Adicionar nuvem',
        addEmail: 'Adicionar e-mail',
    options: 'Opções',
        schedule: 'Cronograma',
        ok: 'OK',
        save: 'Salve',
        add: 'Adicionar',
        upgradeNow: 'Atualizar agora',
        from: 'De',
        to: 'Para',
        result: 'Resultado',
        fileProcess: 'Arquivos processados',
        transferFiles:'Arquivos',
        dataProcess: 'Dados processados',
        startTime: 'Hora de início',
        currentRate: 'Taxa atual',
        endTime: 'Fim do tempo',
        timeRemaining: 'Tempo restante',
        averageRate: 'Taxa média',
        averageRateSpecial: 'Taxa média',
        viewFailed: 'clique para visualizar os arquivos com falha',
        fileSuccess: 'Sucesso na transferência de todos os arquivos',
        size: 'Tamanho',
        executedTimes: 'Tempos executados',
        sourceDir: 'Diretório de origem',
        cause: 'Causa',
        retry: 'Tente novamente',
        retryMin: 'Tente novamente',
        clean: 'Limpar',
        properties: 'Propriedades',
        copy: 'Copiar',
        move: 'Mover',
        multiSelect: 'Seleção múltipla',
        close: 'Fechar',
        copyTo: 'Copiar para',
        tranTo: 'Overzetten naar',
        syncWith: 'Synchroniseren met',
        backupTo: 'Back-up maken naar',
        download: 'Baixar',
        delete: 'Excluir',
        more: 'Mais',
        preview: 'Pré-visualização',
        share: 'Compartilhar',
        shareWith: 'Compartilhar com MultCloud',
        shareTransfer: 'Criar uma transferência',
        encrypt: 'Criptografar',
        encryptFile: 'Somente criptografar arquivo',
        encryptFileName: 'Criptografar arquivo e nome',
        decrypt: 'Descriptografar',
        decryptFile: 'Descriptografar apenas arquivo',
        decryptFileName: 'Descriptografar arquivo e nome',
        onedriveBusinessContentNote: 'Nota',
        oneDrive4BusinessContent: 'Se você é um administrador e atribuiu uma licença do Microsoft 365 a um usuário, mas recebeu um erro de "Acesso negado" ao tentar acessar a pasta do usuário via MultCloud, tente os seguintes passos:',
        oneDrive4BusinessTips1: `Vá para "<a href="https://admin.microsoft.com/" target="_blank" class='add-onedrivebuiness-link'>Administrador</a>". Selecione a guia "Usuários" > "Usuários ativos" > Selecione a opção "Gerenciar licença do produto".`,
        oneDrive4BusinessTips2: 'Vá até a aba “OneDrive” e clique em “Criar link para arquivo”. Depois, volte para MultCloud e tente acessar a conta novamente.',
        oneDrive4BusinessStep1: 'Passo 1',
        oneDrive4BusinessStep2: 'Passo 2',
        upStep: 'Anterior',
        nextStep: 'Próximo',
        complete: 'Completar',
        cut: 'Cortar',
        viewDetails: 'Ver detalhes',
        toOfficialSite: 'Offizielle Seite',
        btLinkTask: 'Tarefa remota',
        fileName: 'Nome do arquivo',
        itemsSelected: 'itens selecionados',
        dateModified: 'Data modificada',
        rename: 'Renomear',
        paste: 'Colar',
        btLink: 'Upload Remoto',
        load: 'Carregando',
        status: 'Estado',
        operate: 'Operar',
        failure: 'Fracasso',
        link: 'Ligação',
        cleanList: 'Lista limpa',
        type: 'Tipo',
        account: 'Conta',
        name: 'Nome',
        selectFailedFile: 'Selecione o arquivo com falha',
        transferring: 'Transferindo',
        newPassword: 'Nova senha',
        confirmPassword: 'Confirme a Senha',
        done: 'Feito',
        no: 'No',
        yes: 'Sim',
        attention: 'Atenção',
        cancel: 'Cancelar',
        unsubscribe: 'Cancelar inscrição',
        reactivate: 'Reative-o',
        sureCleanAll: 'Tem certeza de que deseja limpar todas as tarefas concluídas?',
        failedFiles: 'Arquivos com falha',
        minTo: 'para',
        retryAll: 'Repetir tudo',
        viewProgress: 'Ver Progresso',
        taskNotRun: 'Esta tarefa não está sendo executada.',
        success: 'Sucesso',
        failure: 'Fracasso',
        canceled: 'Cancelado',
        patial: 'Sucesso Parcial',
        syncDetails: 'Detalhes da sincronização',
        width: 'Largura',
        sync: 'Sincronizar',
        targetCloud: 'Unidades de nuvem de destino',
        running: 'Correndo',
        preparing: 'Preparando',
        waiting: 'esperando',
        target: 'Alvo',
        noVip: 'Agora você tem no máximo 2 arquivos transferidos simultaneamente. Atualize para qualquer serviço premium para ter no máximo 10!',
        vipThanks: 'Obrigado por assinar nosso serviço. Agora você tem no máximo 10 arquivos transferindo simultaneamente.',
        emailAccount: 'Conta de e-mail',
        with: 'Com',
        syncing: 'A sincronizar',
        selectAll: 'Selecionar tudo',
        date: 'Encontro',
        failed: 'Falhou',
        skip: 'Pular',
        replace: 'Substituir',
        ready: 'Pronto',
        connecting: 'Conectando',
        account: 'Conta',
        selectNull: 'Selecione um diretório de destino.',
        selectOther: 'Este diretório não pode ser selecionado para colar arquivos, você pode selecionar seus subdiretórios ou outros diretórios.',
         //2020-10-26-ljm新增
        filterHolder:'Insira uma extensão de arquivo aqui.Eg mp4',
        countFiles:'Contando arquivos',
         //2020-8-18-xth新增
        editShare: 'Editar compartilhamento',
        toSource: 'Para Fonte',
        copyLink: 'Link de cópia',
        toShare: 'Compartilhar',
        report: 'Relatório',
        expand: 'Estender',
        shrink: 'Encurta',
          //2020-12-2-ljm新增
        upgradeMulti:'Atualizar para multithread',
        team: "Arquivos da equipe",
        loadData:'Carregando dados, por favor aguarde',
        getAccountInfo:'Não é possível obter as informações da conta, faça login novamente e tente novamente.',
        loadingData:'Carregando dados',
        failedEmptyTip: 'Falha no carregamento de arquivos com falhas. Favor entrar em contato com <a href="mailto:support@multcloud.com">support@multcloud.com</a> para obter mais ajuda.',
        runNow:'Corra agora',
        emailFilter: 'Filtro de e-mail',
        me: "mim",
        reset: "Reiniciar",
        apply: "Aplicar",
        failureReason: 'Motivo da falha',
        countingFilesTip: 'Calculando ({num} arquivos)',
        taskName: 'Nome da Tarefa',
        frequency: 'Freqüência:',
        canceling: 'Cancelamento em andamento...',
    },
    rightTopBanner: {
        navTransfer: 'Transferência de Nuvem',
        navInstagram: 'Instagram Downloader',
        navVideo: 'Baixador de Vídeos',
        navWeb: 'Baixador de imagens',
        traffic: 'Tráfego',
        upgrade: 'Melhoria',
        settings: 'Definições',
        changePassword: 'Mudar senha',
        changeName: 'Tornar nome',
        bindEmail: 'Vincular email',
        deleteAccount: 'Deletar conta',
        language: 'Língua',
        help: 'Socorro',
        notifications: 'Notificações',
        notification: 'Notificaçõe',
        subAccounts: 'Subcontas',
        logout: 'Sair',
        tutorials: 'Tutoriais',
        contact: 'Contato',
        limitsClouds: 'Limites de nuvens',
        faq: 'Perguntas frequentes',
        purTraffic: 'Comprar tráfego',
        unlimitedPlan: 'Membro sênior',
        monthlyUnlimitedPlan: 'Plano mensal ilimitado',
        rememberOriginal: 'Lembre-se do seu nome de usuário original:',
        andPassword: 'e senha',
        bindEmailOpen: 'Melhor para <span style="color:#8a96e3;cursor:pointer;" id="bindEmailOpen">vincule seu endereço de email e altere a senha padrão</span> por segurança e conveniência.',
        lifeSwitchTip: 'Com o serviço ilimitado vitalício, você pode transferir arquivos entre nuvens, sem limites de tráfego.',
        lifeTimePlan: 'Ilimitado por vida',
        browserPrompt:'Para uma melhor experiência do usuário, sugerimos usar o Google Chrome.',
        unlimited:'Ilimitado',
        lifeTimeNotice:'Você é um usuário MultCloud Lifetime Unlimited.',
        subAccount:"Sub conta",
        bindMailTips:"Por favor, vincule seu e-mail para desbloquear a transferência de arquivos na nuvem e aproveite ao máximo o MultCloud.",
        bind:"Ligar",
    },
    popup: {
        userStarPopup: {
            starDesc: "Como está a ser a sua experiência até agora?",
            ok: "OK",
            thankYou: "Obrigado!",
            thankYouDesc: "Se pudesse partilhar a sua experiência real e honesta com o nosso produto, ajudaria a manter a nossa pequena equipa motivada para tornar o MultCloud ainda melhor.",
            reviewStart: "Avalie-nos na",
            reviewEnd: "",
            feedbackTitle: "Como podemos melhorar?",
            feedbackDesc: "Adicione os seus comentários",
            feedbackBtn: "Enviar",
            feedbackYes: "Obrigado pelo seu feedback.",
            feedbackNo: "Introduza os seus comentários.",
        },
        addCloudPopup: {
            endpointOptional:'Ponto final (opcional)',
            //2020.09.23 添加NAS云盘
            addNas: 'ADICIONAR NAS',
            addNasFtpDes: `Conecte NAS via FTP. Não sabe como configurar FTP para NAS? Por favor<a href="https://www.multcloud.com/help/enable-ftp-service-on-synology-nas.html" target="_blank" class='add-cloud-link'>clique aqui</a>`,
            addNasWebDes: `Conecte NAS via WebDAV. Não sabe como configurar WebDAV para NAS? Por favor<a href="https://www.multcloud.com/help/enable-webdav-service-on-synology-nas.html" target="_blank" class='add-cloud-link'>clique aqui</a>`,
            bucketName: 'Nome do intervalo',
            accessKeyId: 'ID da chave de acesso',
            idriveKeyId: 'Access Key ID',
            secretAccessKey: 'Chave de acesso secreta',
            idriveSecretAccessKey: 'Secret Access Key',
            endpoint: 'Endpoint',
            displayName: 'Nome em Exibição',
            addFtp: 'ADICIONAR FTP',
            addFtpDes: 'Para conectar seu FTP, o MultCloud precisa que você insira seus detalhes de autenticação.',
            egnyteTip: `Dicas: Para obter sua chave e segredo, você precisará do ID de gerenciamento da API Egnyte. Se não tiver um, você pode se <a href="https://developers.egnyte.com/member/register" target="_blank" class='add-cloud-link'>registrar aqui</a>.`,
            icedriveTip: 'Nota:',
            icedriveTip1: '1. Suporta apenas contas Premium do Icedrive.',
            icedriveTip2:`2. Clique no seu nome de usuário Icedrive -> 2FA e acesso -> WebDAV -> Ativar -> Mostrar chave. A Chave de Acesso é a senha.`,
            iCloudPhotosTip: 'Pontas:',
            iCloudPhotosTip1: '1. Antes de conectar suas fotos do iCloud ao MultCloud, certifique-se de que "Acessar dados do iCloud na Web" esteja ativado.',
            iCloudPhotosTip1Q: `Como gerenciar o acesso web aos seus dados do iCloud:<br><br>No iPhone ou iPad<br>1. Abra o aplicativo Configurações.<br>2. Toque no seu nome e depois em iCloud.<br><br>3. Toque para desligar ou ativar o Acesso aos dados do iCloud na Web.<br>
            <br>No Mac<br>1. Escolha menu Apple > Configurações do Sistema.<br>2 Clique no seu nome e depois em iCloud.<br>3. Clique para desligar ou ativar o Acesso aos dados do iCloud na Web.`,
            iCloudPhotosTip2: '2. O iCloud Photos suporta apenas os seguintes formatos de imagem: jfif, pjpeg, jpeg, pjp, jpg, HEIC.',
            server: 'server',
            protocol: 'Protocolo',
            port: 'Porta',
            passive: 'Modo passivo',
            passphrase: 'Frase de acesso',
            explanation: 'Para se conectar ao FTP, o prefixo deve ser "ftp://" ou prefixo está ausente.Se a sua porta FTP não for o padrão, é um número de porta especial, como 21,use o formato para especificar a porta abaixo:ftp://ftp.myhost.com:21',
            userName: 'Nome do usuário',
            passWord: 'Senha',
            advanced: 'Avançado',
            commFTP: 'FTP comum',
            transMode: 'Transfer mode',
            encoding: 'Codificação',
            path: 'Caminho (opcional)',
            cloudName: 'Nome da nuvem',
            cloudService: 'Serviço na nuvem',
            addedTime: 'Hora adicionada',
            userName: 'Nome do usuário',
            usedSpace: 'Espaço utilizado',
            totalSpace: 'Espaço total',
            iCloudUsedSpace: 'Fotos iCloud Espaço usado',
            iCloudDriveUsedSpace: 'iCloud Drive Espaço usado',
            iCloudTotalSpace: 'Armazenamento total iCloud',
            iCloudDriveTotalSpace: 'Armazenamento total iCloud',
            removeContent: 'Algumas tarefas de transferência de nuvem são baseadas nesta nuvem. Ainda deseja removê-lo?',
            google_driveTips: 'Ao transferir arquivos ou pastas do Google Drive para outro, verifique se não existem os mesmos nomes de arquivo no mesmo diretório.',
            baiDuTips: 'Só pode fazer upload ou transferir para o directório de "全部文件/我的应用数据/lin1118"',
            mySQLQuestion: 'Você precisa digitar seu endereço IP do servidor MySQL no campo servidor e a porta padrão é 3306 ou você deve inserir sua porta personalizada.',
            webDavQuestion: `Se você usar uma conexão SSL segura, adicione o prefixo "https: //" ao seu host ou não faça nada e a porta padrão é 443; caso contrário, o prefixo deve ser "http: //" e a porta padrão é 80.
                por exemplo. https://dav.box.com/dav`,
            egnyteQuestion: 'Entre na Engnyte e encontre seu domínio na barra de endereços. Digite o domínio neste formato: por exemplo https://aomeitech.egnyte.com/',
            ownCloudQuestion: `Se você usar uma conexão SSL segura, adicione o prefixo "https: //" ao seu host ou não faça nada e a porta padrão é 443; caso contrário, o prefixo deve ser "http: //" e a porta padrão é 80`,
            amazonQuestion: `Visite a página para aprender <a href="https://www.multcloud.com/tutorials/s3-key.html" target="_blank" class='add-cloud-link'>como obter o ID da chave de acesso do Amazon S3.</a>`,
            boxTips: `O Box não suporta a transmissão de um único arquivo com mais de 2 GB.`,
            google_drive_sharedWithMeTips:'Ao transferir arquivos para pastas de nuvem "Shared With Me Drive", certifique-se de estar autorizado com a "permissão de upload".',
            gSuiteSharedDriveTips:'Ao transferir arquivos para pastas de nuvem "Shared Drive", certifique-se de estar autorizado com "permissão de upload".',
            webDavTips: `1.Verifique se você possui permissões de leitura / gravação antes das operações do arquivo; caso contrário, o MultCloud poderá não conseguir transferir arquivos para o seu WebDav.
                2. Verifique se há espaço suficiente para suas operações. Estamos temporariamente incapazes de identificar seu tamanho.`,
            aDriveTips: 'Suportamos contas pessoais Premium e comerciais, mas não a conta pessoal básica no momento.',
            yandexTips: `1.Verifique se há espaço suficiente para suas operações. Estamos temporariamente incapazes de identificar seu tamanho.
                         2.Se você ativou a senha do aplicativo, por favor digite a senha do aplicativo no campo de senha acima.`,
            googlePhotosTips: `1.O diretório "Fotos" pode armazenar apenas imagens, vídeos e outros arquivos de mídia, mas não os diretórios.
                2.O diretório "Álbuns" pode armazenar apenas diretórios de álbuns, mas não arquivos de mídia.
                3.O diretório "Compartilhamento" contém todos os álbuns compartilhados por você ou os álbuns compartilhados aos quais você ingressou.
                4.O Google Fotos suporta apenas o upload de imagens, vídeos e outros arquivos de mídia. E ao usar a função de upload do MultCloud, você só pode enviar arquivos para os diretórios do álbum criados ou compartilhados pelo MultCloud.
                5.Ao usar a função de compartilhamento de fonte do MultCloud, você pode compartilhar apenas os álbuns criados pelo MultCloud.
                6.Todos os álbuns sem título serão exibidos como "Sem título".
                7.Atualmente, a função downlaod está disponível, mas a descodificação de arquivos originais não é suportada.
                8.Atualmente, não há suporte para funções de cortar, excluir e renomear. E você não pode usar as funções que dependem dessas operações.`,
            googlePhotosV2Tips: `1.O diretório "Fotos" pode armazenar apenas imagens, vídeos e outros arquivos de mídia, mas não os diretórios.
                2.O diretório "Álbuns" pode armazenar apenas diretórios de álbuns, mas não arquivos de mídia.`,
            evernoteTips: `1. Limites de taxa da API. <a href='https://dev.evernote.com/doc/articles/rate_limits.php' target="_blank" class='add-cloud-link'> Ver detalhes>> </a>
                  2. Quais são os limites do sistema do Evernote? <a href='https://help.evernote.com/hc/en-us/articles/209005247-What-are-the-system-limits-of-Evernote-' target="_blank" class='add-cloud-link'>Ver detalhes>></a>
                  3. Você só pode enviar um arquivo com menos de 50 MB para a anotação.
                  4. Não é possível renomear ou excluir os arquivos de conteúdo das notas (. ENML).
                  5. Só pode copiar as notas para o caderno.`,
            flickrTips: `1. Você só pode transferir fotos ou vídeos para o Flickr.
                2. As pastas só podem ser transferidas para o diretório "Álbuns" e não pode haver subdiretórios no diretório "Álbuns".
                3. Os arquivos podem ser transferidos apenas para o diretório "My Photostream" ou "Albums" criado por você.
                4. Todos os seus arquivos podem ser encontrados no diretório "My Photostream".
                5. Todos os arquivos no diretório "Álbuns" são referenciados no diretório "My Photostream".`,
            mediafireTips: 'O upload e o download de arquivos vazios não são suportados. Pode levar muito tempo para abrir uma pasta que contém muitos arquivos.',
            mySQLTips: `1. Seu banco de dados precisa estar acessível a partir de nossos endereços IP, que são 209,126.%. Você pode criar um novo usuário através do banco de dados ou da interface do host. O comando MySQL é o seguinte:
                <span class='add-mysql-link'>GRANT SHOW DATABASES, SELECT, LOCK TABLES, RELOAD ON *.* TO username@'209.126.%' IDENTIFIED BY 'password'</span>;
                2. Seu servidor pode precisar adicionar uma regra de firewall aos nossos endereços IP e porta acessada (a porta padrão é 3306) para acessar seus bancos de dados normalmente.`,
            hubiCTips: `1. Uma conta hubiC pode adicionar apenas uma vez.
                2. Você não pode renomear e cortar arquivos ou pastas.
                3. Pode demorar um pouco para excluir pastas com muitos arquivos.
                4. O hubiC não suporta a transmissão de um único arquivo com mais de 5 GB.
                5. Os nomes de arquivos não podem exceder 248 caracteres e os nomes de pastas são limitados a 256 caracteres.`,
            gSuiteUpTips: `A conexão entre o G Suite e o MultCloud está disponível apenas para administradores do G Suite. Para conectar o G Suite ao MultCloud, você precisa "DOMAIN INSTALL" nossa G Suite Marketplace app --- <a href='https://gsuite.google.com/marketplace/search/Cloud%20Transfer%20-%20MultCloud?hl=en' target="_blank" class='add-cloud-link'>"Cloud Transfer - MultCloud"</a> primeiro.`,
            gSuiteTips: `1.Você deve ser um <a href="https://support.google.com/a/answer/2405986?hl=en" target="_blank" class='add-cloud-link'> Administrador do G Suite</a>.
                            2.Como verificar se é uma conta de administrador? Primeiro, consulte este link <a href='https://support.google.com/a/answer/2406043' target="_blank" class='add-cloud-link'> https://support.google.com/a/answer/2406043</a>. Segundo, entre na sua conta Gsuite a partir do link. Terceiro, você pode encontrar os resultados na linha "Para criar uma função personalizada".
                            3.o <a href='https://support.google.com/a/answer/60757?hl=en' target="_blank" class='add-cloud-link'>Acesso à API </a> está ativado.
                            4.Antes de adicionar esta unidade na nuvem, você deve instalar o nosso <a href='https://gsuite.google.com/marketplace?hl=en' target="_blank" class='add-cloud-link'> Aplicativo G Suite Marketplace </a> "MultCloud for G Suite" primeiro e verifique se <a href='https://admin.google.com/' target="_blank" class='add-cloud-link'> setup </a>  está correto: o status está ativado e o acesso a dados é concedido.`,
            hiDriveTips: `1.Por favor, certifique-se de ter uma conta com protocolo WebDAV habilitado e permissões de leitura/gravação antes de trabalhar com arquivos, caso contrário MultCloud pode não ser capaz de transferir arquivos para seu HiDrive.
                2. Verifique se há espaço suficiente para suas operações. Estamos temporariamente incapazes de identificar seu tamanho.`,
            backblazeTips: `1.Cada nome do bloco deve ter pelo menos 6 caracteres.
                2.Quando você cria uma nova chave de aplicativo, a antiga não funciona mais.
                3.Os nomes dos arquivos não podem começar com "/", terminar com "/" ou conter "//".`,
            WEBDETips: `1.Verifique se você possui permissões de leitura / gravação antes das operações do arquivo; caso contrário, o MultCloud poderá não conseguir transferir arquivos para o seu Web.De.
                2. Verifique se há espaço suficiente para suas operações. Estamos temporariamente incapazes de identificar seu tamanho.`,
            alfrescoTips: `Como uma conta Alfresco gratuita, seu espaço de armazenamento para rede é de 10 GB e o limite de tamanho de arquivo individual é de 50 MB.`,
            cloudMeTips: `1.Verifique se você possui permissões de leitura / gravação antes das operações do arquivo; caso contrário, o MultCloud poderá não conseguir transferir arquivos para o seu CloudMe.
                2. Verifique se há espaço suficiente para suas operações. Estamos temporariamente incapazes de identificar seu tamanho.`,
            myDriveTips: `Verifique se há espaço suficiente para suas operações. Estamos temporariamente incapazes de identificar seu tamanho.`,
            cubbyTips: `1.Por favor, verifique se você possui permissões de leitura / gravação antes das operações do arquivo; caso contrário, o MultCloud poderá não conseguir transferir arquivos para o Cubby.
                2. Verifique se há espaço suficiente para suas operações. Estamos temporariamente incapazes de identificar seu tamanho.`,
            cloudType: 'Tipo de nuvem',
            notificationTip: `Obrigado por usar o MultCloud mais recente, se houver algum problema, feedback para:<a href="mailto:support@multcloud.com">support@multcloud.com</a>,obrigado.`,
            notAbleAccess: 'Não é possível acessar o problema do Google Fotos resolvido',
            problemNotAccess: 'O problema de não conseguir acessar o Google Fotos foi corrigido. Se você ainda não consegue acessar o Google Fotos, adicione-o novamente ao MultCloud.',
            noPrompt: 'Não apareça na próxima vez',
            addFeatures: 'Alguns novos recursos adicionados abaixo:',
            version: 'Versão:',
            applicationKey: 'applicationKey',
            keyID: 'keyID',
            privateKey: 'Arquivo de chave privada para autenticação (opcional)',
            FTPTips:`1. Você precisa ter acesso de leitura e gravação ao diretório e aos arquivos do FTP, caso contrário você não poderá manipulá-los.
            2. Como o tamanho do FTP não é reconhecido, verificar se o tem espaço suficiente.
            3. Se você não conseguir acessar o ftp normalmente, adicionar 209.126.103.1/19 e 207.38.89.1/24 à lista de permissões de parede corta-fogo.`,
            specialDropBox:`Se você é um administrador do Dropbox Business e gostaria de acessar todas as contas de sua organização, por favor clique em "Acessar organização".`,
            specialDropBoxBottom:`Se você deseja acessar sua nuvem pessoal, por favor clique em "Acessar nuvem pessoal".`,
            accessOrganization:'Acessar Organização',
            accessPersonalCloud:'Acessar nuvem pessoal',
            specialBoxBusiness:`Se você é um administrador de box for Business e gostaria de acessar todas as contas de sua organização, por favor clique em "Acessar Organização".`,
            specialgSuite:`Se você é um <a href='https://support.google.com/a/answer/2405986?hl=pt' target="_blank" class='add-cloud-link'> administrador de Google Workspace </a> e gostaria de acessar todas as contas de sua organização, por favor "INSTALAR O DOMÍNIO" este aplicativo G Suite Marketplace app --- "<a href="https://gsuite.google.com/marketplace/app/cloud_transfer_multcloud/72136911391?hl=pt" target="_blank" class='add-cloud-link'>Cloud Transfer – MultCloud</a>"primeiro. e cilque em "Acessar Organização".`,
            specialOnedrive:`Se você é um administrador de OneDrive for Business e gostaria de acessar todas as contas de sua organização, por favor clique em "Acessar Organização".`,
            iCloudPhotosTips:'Por enquanto, o MultCloud não suporta ID Apple sem e-mail.',
            appleId: 'ID Apple',
            addICloudPhotos: 'Adicionar iCloud Fotografias',
            addICloudDrive: 'Adicionar iCloud Drive',
            fourShared: `Observação: a autorização 4shared é válida por<span style="color: red"> 2 horas. </span>Por favor, adicione 4shared novamente e execute suas tarefas manualmente após o vencimento.`,
            fourSharedTips: `Observação: a autorização 4shared é válida por 2 horas. Por favor, adicione 4shared novamente e execute suas tarefas manualmente após o vencimento.`,
        },
        cloudExploerPopup: {
            googlePhotosV2Tips: 'Dicas para o Google Fotos',
            googlePhotosV2TipsDesc: 'O Google atualizou a API do Google Fotos em 7 de maio de 2025. Para acomodar essas mudanças, precisamos implementar as seguintes atualizações:',
            googlePhotosV2Tips1: 'A pasta "Álbuns" agora exibirá apenas álbuns criados pelo MultCloud.',
            googlePhotosV2Tips2: 'A pasta "Fotos" agora exibirá apenas imagens enviadas pelo MultCloud.',
            googlePhotosV2Tips3: 'Para transferir imagens do Google Fotos para outros serviços de nuvem, clique no botão "Adicionar mais fotos" e conceda ao MultCloud acesso às imagens que deseja transferir.',
            googlePhotosV2Tips4: 'Para transferir imagens de outros serviços de nuvem para o Google Fotos, observe que apenas pastas podem ser transferidas para a pasta "Álbuns" e apenas imagens individuais podem ser transferidas para a pasta "Fotos".',
            googlePhotosV2TipsShow: 'Não mostrar isso novamente',
            googlePhotosV2AddMore: 'Adicionar mais fotos',
            googlePhotosV2AddMoreTips: 'Clique aqui para adicionar as imagens que deseja adicionar ao MultCloud.',
            googlePhotosV2FolderName: 'Nome da pasta',
            googlePhotosV2FolderNameInput: 'Digite um nome para a pasta onde as imagens serão salvas.',
            googlePhotosV2NotSelect: 'Você ainda não adicionou nenhuma foto. Clique em "Adicionar mais fotos" para adicionar imagens ao MultCloud.',
            googlePhotosV2SelectAlbums: 'Você só pode salvar pastas em "Álbuns".',
            googlePhotosV2SelectAlbum: 'Você só pode salvar imagens e vídeos nesta pasta.',
            googlePhotosV2SelectPhotos: 'Você só pode salvar imagens e vídeos em "Fotos".',
            googlePhotosV2SelectSession: 'Esta pasta não pode ser selecionada como destino. Selecione a pasta "Álbuns" ou "Fotos".',
            deleteContentEver: 'Tem certeza de que deseja excluir os itens selecionados permanentemente?<br>Depois de excluído, ele não pode ser restaurado da Lixeira.',
            deleteContent: 'Tem certeza de que deseja excluir os itens selecionados?',
            detailedProgress: 'Progresso detalhado',
            highSpeed: 'A pesquisa em alta velocidade suporta as seguintes unidades de nuvem',
            takeMoreTime: 'Pode levar mais tempo com as seguintes unidades de nuvem',
            enterKeyWord: 'Digite a palavra-chave',
            highSpeedSearch: 'Pesquisa em alta velocidade',
            normalSearch: 'Pesquisa Normal',
            shareWithOthers: 'Compartilhar com outras pessoas',
            inviteByEmail: 'Convide pessoas por email',
            pleaseEnterEmail: 'Digite e-mails e separe-os com vírgula',
            addMessage: 'Adicione uma mensagem (opcional)',
            shareTo: 'Compartilhar com',
            noLink: 'Nenhum link criado ainda',
            createShare: 'Criar compartilhamento',
            cancelAllTask: 'Tem certeza de que deseja cancelar todas as tarefas?',
            //2020/8/7-xth
            shareEmailTitle: 'Enviar link por e-mail',
            shareNotSupportSource: 'Este serviço de nuvem não suporta este recurso, tente outra opção de compartilhamento',
            shareSendEmail: 'Enviar email',
            generateLinkSuccess: 'Link de compartilhamento criado',
            generateLinkFail: 'Falha ao criar link de compartilhamento',
            emailSentSuccessful: 'Emails enviados',
            emailSentNull: 'Você ainda não inseriu um e-mail',
            emailSentNotice: 'Por favor insira um e-mail correto',
            linkCopySuccessful: 'Link copiado!',
            sharePrivateLink: 'Link de compartilhamento privado: ',
            sharePrivatePassword: ' Ver senha: ',
            cancelMyShareTask: 'Tem certeza que deseja cancelar o compartilhamento? Este link não funcionará mais para quem o possui.',
            cancelMyShareOk: 'Sim cancele',
            cancelMyShareNot: 'Não, vou ficar com ele',
            emailArrayToLong50: 'Você pode enviar 50 e-mails de uma vez.',
            shareOnEmail: 'Enviar link via e- mail',
            shareOnFacebook: 'Compartilhar no Facebook',
            shareOnTwitter: 'Compartilhar no Twitter',
            shareOnTumblr: 'Compartilhar no Tumblr',
            shareOnPinterest: 'Compartilhar no Pinterest',
            shareOnLinkedIn: 'Compartilhar no LinkedIn',
            ceateShareError: 'Falha ao criar o compartilhamento, verifique sua rede.'
        },
        cloudTransferPopup: {
            pleaSelect: 'Por favor selecione',
            schedule: 'Cronograma',
            checkScheduled: 'Marque a caixa \'Agendado \' desta tarefa para ativar o editor de agendamento.',
            addValidCloud: 'Você deve adicionar uma unidade de nuvem válida',
            //2020-10-26-ljm增加
            cleanList:'Lista Limpa'

        },
        personalCenter: {
            changePassword: ' Mudar senha',
            changeName: 'Tornar nome',
            deleteAccount: ' Deletar conta',
            enterPassWord: 'Por favor, insira sua senha',
            note: 'Nota: por favor, deixe-nos saber o motivo pelo qual você saiu, faremos o possível para corrigi-lo.',
            sureDeleteAccount: 'Tem certeza de que deseja excluir esta conta?',
            unsubscribe: 'Antes de excluir esta conta, cancele sua inscrição primeiro no MultCloud.',
            bindEmail: 'Vincular email',
            pleaseSwitch: 'Por favor, mude para o MultCloud clássico para descriptografar os arquivos.',
            switchOld: 'Mude para o clássico',
            pleaseUnsubscribe: 'Por favor, mude para o MultCloud clássico para cancelar a assinatura do seu serviço premium primeiro.',
            deletePremium: 'Você está prestes a excluir uma conta premium. Depois de excluí-lo, você nunca mais poderá recuperá-lo. Tem certeza que ainda quer fazer isso?'

        },
        remoteTaskPopup: {
            addLinkTask: ' Adicionar tarefa de link',
            validLink: 'Digite um link válido',
            saveCloud: 'Salvar na nuvem',
            parseFail:'falha ao analisar',
			inadmissibleRequest:'Um pedido não suportado',
			createBtTask: 'Criar tarefa BT',
			emptySource: 'Insira um link ou envie um arquivo torrent',
			validTorrent: 'O arquivo torrent selecionado é inválido',
			addTorrent: 'Adicionar Torrent',
			tip: 'Selecione uma nuvem para salvar o arquivo',
			torrentSelected:'Nome({num}/{all})',
			urlLinkSupported:'Copie e cole o link aqui, links http/https/magnet suportados,\nObservação: não use o MultCloud para fazer download ou upload de materiais copiados não autorizados e violadores.',
			torrentStore:'Selecione uma nuvem para armazenar o arquivo torrent',
			downloadLink:'Por favor, insira um link para download',
			cancelTask:'Cancele a tarefa',
			cancelTaskContent:'Tem certeza de que deseja cancelar a tarefa?',
			parseTaskRunning:"MultCloud já está executando um processo de análise, vá para \"O carregamento remoto\" para verificar."
        },
        taskListPopup: {
            deleteTask: 'Excluir tarefa',
            pleaseSelect: 'Selecione os dados antes de excluir.',
            sureDeleteTask: 'Tem certeza de que deseja excluir as tarefa(s)?',
            deleteSingleTask: 'Tem certeza de que deseja excluir as tarefa?',
            viewLogs: 'Ver registros',
            selectCloud: 'Por favor, selecione a nuvem para salvar os arquivos'
        },
        upgradeAccountPopup: {
            commonTitle: '5 tarefas em paralelo de nuvem a nuvem',
        commonDes: 'Por favor, atualize para assinante e você será capaz de executar 5 tarefas de nuvem a nuvem em paralelo.',
        upgradeAccount: 'Atualizar conta ',
            upgradeHeadTitle:'5 links paralelos ou torrents',
			upgradeHeadContent:'Usuários gratuitos podem ter um link de transferência ou tarefa de torrent por vez. Atualize para assinante e você terá 5 tarefas de link de transferência ou torrent transferindo ao mesmo tempo',
            currentPlan: 'Plano atual ',
            insufficientTraffic: 'Tráfego nuvem-a-nuvem insuficiente ',
            insufficientTrafficDes: 'Você consumiu todo o tráfego de dados gratuito deste mês. Para obter mais tráfego, atualize para a versão premium.',
            filter: 'Filtro de transferência / sincronização de arquivos ',
            filterDes: 'Para ativar o filtro de transferência / sincronização de arquivos, atualize para a versão premium.',
            offlineFree: '1 link ou torrent por vez',
            offlinePremium: '5 links paralelos ou torrents',
            modes: 'Modos de sincronização avançados ',
            modesDes: 'Os assinantes têm sincronização bidirecional e 7 opções personalizadas na sincronização unidirecional. Sincronização de backup incremental suportada.',
            // : 'SincrodoubledSyncnização dupla',
            // doubleSyncDes: 'Atualize para assinante e tenha duas tarefas de sincronização sendo executadas simultaneamente.',
            doubleRealTime:'Sincronização em tempo real duplicada',
            doubleRealTimeSyncDes:'Atualize para assinante e execute duas tarefas de sincronização em tempo real simultaneamente.',
            doubledSync: 'Sincronização Normal Duplicada',
            doubleSyncDes: 'Atualize para assinante e execute duas tarefas normais simultaneamente.',
            realTimeSyncing:'Sincronização em tempo real duplicada',
            norMalSyncing:'Sincronização Normal Duplicada',
            free: 'Livre',
            premium: 'Prêmio',
            monthTraffic: 'Tráfego de 5 GB / mês',
            syncMode: '2 modos de sincronização',
            scheduled: 'Transferência/Sincronização/Backup regular',
            scheduledDes: 'Para ativar o recurso de cronograma, atualize para a versão premium.',
            moreTraffic: 'Mais tráfego de dados conforme necessário',
            moreSyncModes: '8 modos de sincronização',
            transferSpeed: 'Velocidade de transferência quintuplicada',
            doubleSync: 'Sincronização dupla',
            transferServer: 'Servidor de Transferência VIP',
            customerSupport: 'Suporte ao Cliente VIP',
            syncSupported: ' Sincronização bidirecional e 7 opções personalizadas na Sincronização unidirecional. Mirror Sync suportado.',
            greatlyIncreased: 'Como existem 10 threads para assinantes em vez de dois, a velocidade de transferência aumenta bastante.',
            sameTime: 'Os assinantes podem ter 2 tarefas de sincronização em tempo real e 2 tarefas de sincronização normal (4 no total) realizando simultaneamente.',
            normalSametime:'Os assinantes podem executar duas tarefas de sincronização normais ao mesmo tempo.',
            automatically: 'etup um Filtro para transferir ou sincronizar arquivos com nome de arquivo definido pelo usuário ou determinadas extensões automaticamente.',
            multipleSync: 'Sincronização multi-alvo',
            multipleSyncDes: 'Atualizar para um assinante para desbloquear o recurso "Sincronização multi-alvo.',
            freeDes:'Os usuários gratuitos têm 30 GB de tráfego de dados no total para transferir ou sincronizar dados entre os serviços de armazenamento em nuvem todos os meses.',
            task1: '1 tarefa nuvem a nuvem de cada vez',
            task5: '5 tarefas em paralelo de nuvem a nuvem',
            emailTitle: 'Conversões insuficientes de e-mail',
            emailDes: 'Os usuários gratuitos têm 50 conversões de e-mail por mês, mas parece que você precisa de mais do que isso. Faça upgrade para a versão premium e você terá conversões de e-mail ilimitadas.',
            emailsConversions: '50 conversões de e-mail/mês',
            emailsUn: 'Conversões ilimitadas de e-mails',
        },
        remindBindEmail:{
            bindExe:'Vincule seu e-mail para executar a tarefa',
            onceBind:'Depois de vincular seu e-mail, você também pode obter <span class="gift-flow">30GB</span> de tráfego de dados de tráfego nuvem a nuvem adicional!',
            bindEmail:' Vincule seu e-mail para ativar os recursos principais do MultCloud, se faz favor,.',
            coreFeatures:'Recursos do núcleo do Multcloud',
            tourAccount:'Conta de turismo',
            connectCloud:'Conecte os serviços em nuvem ao MultCloud',
            viewCloud:'Veja todos os arquivos em nuvem via MultCloud',
            uploadFile:'Envie arquivos para nuvens via MultCloud',
            downloadCloud:'Baixe arquivos em nuvem via MultCloud',
            syncAndBackup:'Sincronizar e fazer backup de arquivos entre nuvens',
            transferFiles:'Transfira arquivos de uma nuvem para outra',
            failed:'Falha ao executar a operação, tente novamente mais tarde.'
        },
        salePagePopup:{
            sOffer:'Oferta especial para MONTHLY UNLIMITED',
            timeLimited:'Apresse-se, o tempo é limitado!',
            Hours:'Horário',
            Minutes:'Minutos',
            Seconds:'Segundos',
            monthPrice:'$19.9/mês',
            dataTra:'para tráfego de dados ILIMITADO',
            subscribe:'Inscreva-se agora',
            features:'Recursos',
            freePlan:'Plano Gratuito',
            bigSale:'grande venda por tempo limitado',
            discountsto:'Descontos até',
            off:'25% de desconto',
            premiumPlan:'Plano Premium',
            transmit:'Tráfego para transmissão',
            dataTraffic:'O tráfego de dados para transferência e sincronização de arquivos de nuvem para nuvem.',
            originalPrice:'Preço Original',
            nowOnly:'Agora apenas',
            getDiscount:'Obter desconto',
            moreData:'Mais tráfego de dados',
            unlimitedData:'Tráfego de dados ilimitado',
            syncModes:'Modos de sincronização',
            syncModesDes:'Os assinantes têm sincronização bidirecional e 7 opções personalizadas na sincronização unidirecional. Compatível com Mirror Sync.',
            scheduledTran:'Transferência regular',
            scheduledTranDes:'Com este recurso, você pode definir uma tarefa automática entre nuvem num intervalo regular ou num horário especial.',
            transferSpeedDes:'Existem 10 threads para assinantes, em vez de 2, então a velocidade de transferência é bastante aumentada',
            fileEncryption: 'Criptografia de arquivo',
            encryptFiles:'Os assinantes podem criptografar arquivos em unidades de nuvem online e fazer upload de arquivos',
            quarterly:'Trimestral',
            yearly:'Anual',
            monthGb:'150GB/mensal',
            monthGbly:'200GB/mensal',
            monthfourLy:'400GB/mensal',
            unTr:'Tráfego ilimitado',
            nMonth:'/mês',
            tQuarter:'/Trimestre',
            eYear:'/Ano',
            tOneTime:'Um tempo',
             //2021-10-09
             premiumFeatures:'150 GB de tráfego e todos os recursos avançados por um mês ！',
             unlimitedYear:'Tráfego ilimitado e todos os recursos avançados por um ano ！',
             unlimitedLiftime:'Tráfego ilimitado e todos os recursos avançados para a vida ！',
        },
        properties: 'Propriedades',
        general: 'Geral',
        tips: 'Dicas',
        progress: 'Progresso',
        limits: 'Limites de unidades de nuvem',
        detailed: 'detalhado',
        cancel: 'Cancelar tudo',
        simpleSync: 'Sincronização simples',
        onewaySync: 'Sincronização unidirecional',
        twowaySync: 'Sincronização bidirecional',
        advancedSync: 'Modos de sincronização avançados',
        mirrorSync: 'Sincronização de espelho',
        moveSync: 'Mover sincronização',
        cmuSync: 'Sincronização cumulativa',
        updateSync: 'Atualizar sincronização',
        increSync: 'Sincronização Incremental',
        fullSync: 'Sincronização de backup completo',
        simpleSyncTip: 'Os arquivos adicionados, modificados e excluídos no diretório de origem serão replicados para o diretório de destino. No entanto, os arquivos adicionados, modificados e excluídos no diretório de destino não serão replicados para o diretório de origem.',
        mirrorSyncTip: 'Os arquivos nos diretórios de origem e de destino são sempre os mesmos (o MultCloud excluirá os arquivos extras no diretório de destino).',
        moveSyncTip: 'Depois que a sincronização estiver concluída, todos os arquivos no diretório de origem serão excluídos.',
        cmuSyncTip: 'Ao excluir os arquivos no diretório de origem, os mesmos arquivos no diretório de destino não serão excluídos.',
        updateSyncTip: 'Todos os arquivos no diretório de destino serão excluídos primeiro e, em seguida, os arquivos adicionados e modificados no diretório de origem serão transferidos para o diretório de destino.',
        increSyncTip: 'Sempre que você sincronizar arquivos, um subdiretório será criado no diretório de destino para que os arquivos adicionados e modificados no diretório de origem sejam transferidos para ele.',
        fullSyncTip: 'Sempre que você sincronizar arquivos, um subdiretório será criado no diretório de destino para que todos os arquivos no diretório de origem sejam transferidos para ele.',
        twowaySyncTip: 'Os arquivos adicionados, modificados e excluídos no diretório de origem serão replicados para o diretório de destino. Da mesma forma, os arquivos adicionados, modificados e excluídos no diretório de destino serão replicados para o diretório de origem (ou seja, os arquivos nos diretórios de origem e de destino são sempre os mesmos).',
        syncModes: 'Modos de sincronização',
        email: 'Email',
        filter: 'Filtro',
        once: 'Uma vez',
        thread: 'Thread',
        listThread: 'Número de threads percorridos',
        runThread: 'Número de threads executados',
        sameName: 'Mesmo nome',
        filterInclude: 'Extensões incluídas (ex.: png, doc, mp4)',
        filterExclude: 'Nomes de arquivos excluídos (ex.: target, dist, build)',
        newFilterTag: 'Nova tag',
        createTaskStatus: 'Criado',
        pendingTaskStatus: 'Pendente',
        runningTaskStatus: 'Em execução',
        cancelledTaskStatus: 'Cancelado',
        completedTaskStatus: 'Sucesso',
        failedTaskStatus: 'Falhou',
        warnTaskStatus: 'Aviso',
        errorTaskStatus: 'Erro',
        warning: 'Aviso',
        logs: 'Registro',
        daily: 'Diário',
        weekly: 'Semanal',
        monthly: 'Mensal',
        onlyOnce: 'Executar apenas uma vez:',
        everyDay: 'Executar todos os dias às:',
        everyWeek: 'Toda semana em:',
        at: 'At:',
        sunday: 'Domingo',
        monday: 'Segunda-feira',
        tuesday: 'Terça-feira',
        wednesday: 'Quarta-feira',
        thursday: 'Quinta-feira',
        friday: 'Sexta-feira',
        saturday: 'Sábado',
        runAt: 'Executar em:',
        lastDay: 'Último Dia',
        chooseAction: 'Se o arquivo de destino já existir. Por favor, escolha uma ação:',
        optionsPrompt: 'Se os arquivos na unidade de nuvem de origem tiverem um caractere especial no nome do arquivo que não é permitido na unidade de nuvem de destino, os arquivos se renomearam automaticamente durante o processo de transferência e cria um arquivo log.html no diretório raíz na unidade de destino.',
        sourceNewer: 'Substituir se a fonte for mais recente.',
        diffSize: 'Substituir se tiver tamanho diferente.',
        sourceAll: 'Substituir se o tamanho ou a fonte for mais recente.',
        skipFile: 'Ignorar o arquivo.',
        skipEmail: 'Ignore o e-mail.',
        overWrite: 'Sempre substituir.',
        rename: 'Renomear',
        overWriteSourceNewer: 'Substituir se houver uma atualização do e-mail original. ',
        deleteAllSource: 'Exclua todos os arquivos de origem após a transferência ser concluída.',
        keepFileDate: `Mantenha a data da modificação do arquivo (suporta Dropbox, Google Drive, G Suite).`,
        automaRename: 'Renomeie automaticamente os arquivos com caracteres especiais e gere um arquivo de script.',
        sendEmail: 'Enviar notificação por email ao concluir esta tarefa.',
        sendMessage: 'Envie uma mensagem de teste',
        ignoreFiles: 'Ignorar arquivos com essas extensões',
        includeFiles: 'Incluir apenas arquivos com essas extensões',
        selectSync: 'Você pode selecionar o modo de sincronização aqui:',
        tipsFor: 'Dicas para',
        allTasks: 'Todas as tarefas',
        successful: 'Bem sucedido',
        unfinished: 'Inacabado',
        transferDetails: 'Detalhes da transferência',
        redit: 'Reeditar',
        publicShare: 'Partilha pública',
        publicTip: 'Dicas: Qualquer pessoa que obtiver o link pode visualizar o arquivo',
        privateShare: 'Partilha privada',
        privateTip: 'Dicas: Outros precisam digitar a senha para visualizar o arquivo',
        sourceShare: 'Compartilhamento de origem',
        sourceTip: 'Dicas: Crie um link de compartilhamento da unidade na nuvem de origem',
        shareSuccess: 'Criar compartilhamento bem-sucedido',
        copySuccess: 'Cópia bem sucedida',
        sharedYet: "Este arquivo já foi compartilhado",
        domain: 'Domínio',
        key: 'Key',
        secret: 'Secret',
        //2020-10-26-ljm增加
        progressBox:'Progresso',
        //xth
        publicShareEasy: 'Alguém',
        privateShareEasy: 'Privado',
        communityShareEasy: 'Público',
        sourceShareEasy: 'Fonte',
        reportPopup: {
            title: 'Relatório de compartilhamento',
            beforeMsgOne: 'Ajude-nos a entender o que está acontecendo com este compartilhamento.',
            beforeMsgTwo: 'Como você descreveria isso?',
            typeItems: {
                spam: 'Spam',
                malwareVirus: 'Malware ou vírus',
                copyrightViolation: 'Violação de direitos autorais',
                illegal: 'Conteúdo ilegal',
                notWorking: 'MultCloud não está funcionando corretamente',
                other: 'Outro conteúdo impróprio',
            },
            nextMsgOne: 'Descreva o que está acontecendo com o compartilhamento.',
            description: 'Descrição',
            nextMsgTwo: 'Describe what\'s happening with the share.',
            yourEmail: 'Seu email',
            nextMsgThree: 'Forneça seu endereço de e-mail para que possamos entrar em contato se necessário.',
            submit: 'Enviar',
            back: 'Costas',
            next: 'Próximo',
            messageNone: 'Por favor, insira a descrição deste relatório.',
            emailNone: 'Por favor, insira seu e-mail de contato.',
            success: 'Seu relatório já foi enviado para a equipe MultCloud.'
        },
        subAccountPopup:{
            title: "Gestão de subcontas",
            titleMax: "Gestão de subcontas",
            titleDes:"Atualize para assinante e você poderá criar e gerenciar subcontas.",
            tabNameUser: "Modo de usuário",
            tabNameItem: "Modo de pasta",
            addItemButton: "Atribuir pasta",
            users: "Comercial",
            folders: "Pastas",
            read: "Leitura",
            write: "Escreva",
            questionTxtRead: "Usuários de sub-contas podem baixar, visualizar e copiar arquivos para suas nuvens nesta pasta.",
            questionTxtWrite: "Os usuários de subcontas podem criar novas pastas, fazer upload, excluir e renomear arquivos nesta pasta.",
            userExist:"O usuário já existe.",
            userSelf:"Você não pode se adicionar como sua subconta.",
            quickAssign: "Atribuição rapida",
            quickAdd: "Adicionação rapida",
            allow: "Permitir",
            batchAddUserNull: "Atualmente não há nenhum usuário adicionado.",
            batchAddItemNull: "Atualmente não há nenhuma pasta adicionada.",
            noUserFromAddItem: "Adicione um usuário primeiro, por favor.",
            noItemFromAddUser: "Adicione uma pasta primeiro, por favor.",
            addUser: {
                title: "Adicionar usuário",
                radioCreate: "Crie uma subconta",
                radioAdd: "Adicionar uma conta MultCloud existente",
                createNamePlaceholder: "Criar nome de usuário",
                createPasswordPlaceholder: "Criar senha",
                addNamePlaceholder: "Por favor, indique a conta MultCloud existente",
                createNameNone: "Por favor coloque um nome de usuário.",
                createNameMore: "O nome de usuário deve ter menos de 20 caracteres.",
                createPasswordNone: "Por favor insira uma senha.",
                createPasswordError: "Por favor, insira uma senha com 8-16 caracteres.",
                addUserNameNone: "Insira uma conta MultCloud existente.",
                addUserNone: "Esta conta não existe.",
            },
            addItem: {
                noFolder: "Selecione uma pasta.",
                exist: "Você já adicionou a pasta.",
            },
            editUser: {
                title: "Editar Subconta",
                namePlaceholder: "Digite um nome de usuário",
            },
            cancel: {
                titleUser: "Excluir subconta",
                titleItem: "Remover pasta",
                msgUser: "Tem certeza de que deseja excluir esta conta?",
                msgItem: "Tem certeza de que deseja remover esta pasta?",
            },
            unknownError: "Não foi possível encontrar o caminho, verifique se o caminho existe ou adicione novamente a nuvem.",
        },
        verifyPopup:{
            verifyTitle: "Verifique a sua identidade ",
            toRecoveryText: "Eu não tenho estes",
            verifyEmailTitle: "Verifique o seu e-mail",
            verifyEmailTips: " Enviaremos um código de verificação para {email}. Para verificar se este é o seu endereço de email, introduza-o abaixo.",
            verifyPhoneTitle: "Verifique o seu número de telefone",
            verifyPhoneTips: " Enviaremos um código de verificação para { phone }. Para verificar se este é o seu número de telefone, introduza os últimos 4 dígitos incluindo { last }.",
            verifyPhoneText: "Os últimos 4 dígitos do número de telefone",
            sendCodeBtn: "Enviar código",
            enterCode: "Introduza código",
            checkEmailTips: "Se {email} corresponder ao e-mail alternativo na sua conta, enviar-lhe-emos um código",
            checkPhoneTips: "Se { phone } corresponder aos últimos 4 dígitos do número de telefone da sua conta, enviar-lhe-emos um código",
            askDevice: "Não me pergunte novamente neste dispositivo.",
            verify: "verificar",
            recoveryTitile: "Tem um código de recuperação de conta?",
            recoveryTipsOne: "Se tiver um código de recuperação, introduza-o agora. Se não tiver, por favor contacte",
            recoveryTipsTwo: "O seu código de recuperação tem 25 númeno como: XXXXX-XXXXX-XXXXX-XXXXX-XXXXX-XXXXX",
            recoveryCode: "Código de Recuperação",
            recoveryCodeBtn: "Usar Código de Recuperação",
            recoveryChangeTitile: "O que mais podemos verificar a sua identidade?",
            recoveryEmailChange: "Adicione endereço de e-mail alternativo",
            recoveryPhoneChange: "Adicione o número de telefone",
            enterEmail: "Introduza o seu e-mail",
            recoveryNextTitle: "Por favor introduza o código que enviamos para {checkCode}",
            recoveryTipsTitle: "Para sua protecção, a substituição das suas informações de segurança demora 30 dias!",
            recoveryTips1: "Porque ativou a verificação em duas etapas, precisa de informações de segurança actualizadas para entrar na sua conta",
            recoveryTips2: "Durante o período de espera, não poderá iniciar sessão em site ou serviços com a sua conta, mas poderá iniciar sessão em dispositivos",
            recoveryTips3: "Pode evitar a espera com:",
            recoveryTips4: "Usar um dispositivo de confiança",
            recoveryTips5: "Se tinha um dispositivo que não requer códigos, use-o agora e actualize as suas informações de segurança",
            recoveryTips6: "Encontrar as suas informações de segurança",
            recoveryTips7: "Alguma hipótese que esta não esteja totalmente perdida? Se conseguir encontrá-la, use-o agora para voltar a activar a sua conta",
            recoveryTips8: "A espera torna mais difícil para outra pessoa domina a sua conta com uma palavra-passe roubada",
            recoveryPendTitle: "A sua mudança de informações de segurança ainda está pendente",
            recoveryPendTips1: "Em {data} solicitou que os seus informações de segurança fossem substituídas",
            recoveryPendTips2: "Informação confidencial actual",
            recoveryPendTips3: "E-mail alternativo:",
            recoveryPendTips4: "Número de telefone:",
            recoveryPendTips5: "Novas informações de segurança",
            recoveryPendTips6: "Se desejar manter as suas informações de segurança actuais,",
            recoveryPendTips7: "Cancelar este pedido",
            recoveryCancelTitle: "Aqui é o seu novo código de recuperação",
            recoveryCancelTips1:"Para garantir a sua conta segura, precisa de um novo código de recuperação",
            recoveryCancelTips2: "Se precisar de recuperar o acesso à sua conta, este código irá ajudar. Deverá escrevê-lo e armazená-lo num local seguro. Recomendamos que não armazene o seu código de recuperação num dispositivo",
            recoveryCancelTips3: "Se anteriormente tinha um código de recuperação, e este já não é válido. Utilize este novo código",
            recoveryCancelTips4: "O seu novo código é:",
            recoveryCancelSucTitle: "Óptimo! Vamos voltar para a sua conta!",
            recoveryCancelSucTips1: "A actualização das informações de segurança para { old } foi cancelada, e agora tem acesso à sua conta plenamento",
            recoveryCancelSucTips2: "As informações de contacto utilizadas para iniciar o processo ({new }) foram apagadas e não serão utilizadas como informações de segurança para a sua conta",
            recoveryCancelSucTips3: "Clique em \"Next\" para voltar ao que estava a fazer",
            recoveryCancelErrorTitle: "Enviar pedido",
            recoveryCancelErrorTips: "A sua conta ainda se encontra no período de espera",
            codeText: "Introduza o seu número de telefone",
            exception: {
                emailTwoStringError: "O e-mail correcto começa com \"{errorCode}\".",
                validEmail: "Por favor, introduza um e-mail correcto",
                phoneLastTwoStringError: "O número correcto termina em {errorCode}",
                validPhone: "Deve introduzir os últimos 4 dígitos do número de telefone",
                verificationCodeExpired: "O código de verificação expirou",
                verificationCodeError: "O código de verificação é incorrecto, por favor verifique o código e tente novamente",
                verificationRecoveryCodeExpired: "O código não funcionou, por favor verifique o código e tente novamente",
                verificationCodeNull: "Introduza o código de verificação, por favor.",
            }
        },
        worldBackupPopup: {
            // title:'Dia Mundial de Backup',
            title:'MultCloud oferta especial ',
            titleTip:'Venda em 24 horas',
            timerTitle:'A oferta de tempo limitado terminará em',
            getOffer:'Obter oferta',
            tips100Mo:'100GB/mês de tráfego de dados ',
            ps100Mo:'Dica: O tráfego de dados não utilizados irá se acumular. Por exemplo, você só consumiu 50GB de 100GB no primeiro mês e ainda terá 50GB adicionais no próximo mês.',
            tips1200Yr:'1200GB/ano tráfego de dados',
            ps1200Yr:'Dica: O tráfego de dados não utilizados irá se acumular. Por exemplo, você só consumiu 1000GB de 1200GB no primeiro ano e ainda terá 200GB adicionais no próximo ano.',
            tips2400Yr:'2400GB/ano tráfego de dados',
            ps2400Yr:'Dica: O tráfego de dados não utilizados irá se acumular. Por exemplo, você só consumiu 2000GB de 2400GB no primeiro ano e ainda terá 400GB adicionais no próximo ano.',
            tipsUnYr:'Tráfego de dados ilimitado/ano',
            psUnYr:'Dica: Tráfego de dados ilimitado por ano!',
            tipsUnLi:'Tráfego de dados ilimitado/vida',
            psUnLi:'Tráfego de dados ilimitado para toda a vida!',
            tips1:'10 fios para transferir arquivos',
            tips2:'Transferência na nuvem regular',
            tips3:'24/7/365 suporte prioritário',
            ps1:'Há 10 fios para assinantes, enquanto 2 para usuários grátis, por isso a velocidade de transferência é muito rápida.',
            ps2:'Os assinantes podem definir a transferência/sincronização automática entre nuvens num intervalo regular ou num horário especial.',
            moPrice:'{price} / Mês',
        },
        iosPayTipPopup: {
            title: 'Cancelar assinatura da Apple',
            tip: 'O seu actual {name} está em estado de renovação automática (Apple Transacção ID: {id}), por favor cancele a subscrição e tente novamente.',
            btnTxt: 'Como cancelar',
        },
        appRecommendPopup: {
            title: 'O novo aplicativo móvel MultCloud já está disponível!',
            tip: 'Baixar imediatamente para gerenciar e transferir <br>dados através das nuvens com dispositivos móveis.',
            modileTitle: 'Adquira o aplicativo móvel MultCloud agora!',
            iosBtnTitle: 'Baixar na',
            iosBtnTip: 'App Store',
            androidBtnTitle: 'DISPONÍVEL NO',
            androidBtnTip: 'Google Play',
            apkBtnTitle: 'Download',
            apkBtnTip: 'MultCloud',
        },
        note: 'Nota',
        editCloudNoticPopup: {
            tips: 'A autorização expirou, por favor, volte a ler a nuvem para MultCloud e tente novamente.',
            btnTxt: 'Re-adicionar',
        },
        appleTipsPopup: {
            title: 'Pontas',
            tipTitle: 'Dicas para iCloud Fotos 2-fator auth',
            tip1: 'Para conectar suas fotos iCloud à MultCloud, você precisa conceder ao servidor MultCloud acesso à sua ID da Apple. Assim, você poderá ver a localização de nosso servidor diferente da sua localização real durante o procedimento de auth com dois fatores.',
            tip2: 'E lembre-se: Sua segurança e privacidade são nossa prioridade número 1. MultCloud não armazena seus dados permanentemente. Ele pode armazenar temporariamente parte do conteúdo com base em suas operações, no entanto, ele será removido de nosso servidor imediatamente após a operação estar concluída. E a conexão entre seus servidores iCloud Photos e MultCloud é sempre feita através de um canal seguro SSL de 256 bits.',
            checkTip: 'Não mostre isso novamente',
        },
        iCloudDriveTips: {
            title: 'Pontas',
            tipTitle: 'Dicas para a autenticação de dois fatores do iCloud Drive',
            tip1: 'Para conectar o iCloud Drive ao MultCloud, você precisa conceder acesso ao servidor do MultCloud ao seu ID Apple. Portanto, você poderá ver que a localização do nosso servidor difere da sua localização real durante o procedimento de autenticação de dois fatores.',
            tip2: 'E lembre-se: sua segurança e privacidade são nossa prioridade número 1. O MultCloud não armazena seus dados permanentemente. Ele pode armazenar temporariamente em cache parte do conteúdo com base em suas operações; no entanto, ele será removido de nosso servidor imediatamente após a conclusão da operação. E a conexão entre seu iCloud Drive e os servidores do MultCloud é sempre feita por meio de um canal SSL seguro de 256 bits.',
            checkTip: 'Não mostre isso novamente', 
        },
        checkApplePopup: {
            title: 'Autenticação de dois fatores',
            tip1: 'Você ativou a autenticação de dois fatores. Favor inserir o código de verificação em seu iPhone/iPad/iPod para continuar.',
            tip2: 'Não recebeu um código de verificação?',
            btn1: 'Enviando mensagem...',
            btn2: 'Reenviar Código',
            btn3: 'Me envie um texto',
            btn4: 'Obter apoio',
            suc1: 'Uma mensagem com um código de verificação foi enviada para {num}.',
            suc2: 'Uma mensagem com um código de verificação foi enviada a seus dispositivos.',
            fail1: 'Falha no envio do código de verificação, por favor tente novamente.',
            fail2: 'Por favor, digite o código de verificação para continuar.',
        },
        downloadThreadPopup: {
            title: "Configurações para download",
            tips: "Nome no arquivo baixado",
            defaultNameOne: "Emails saved on {date}",
            defaultName: "{num} emails saved on {date}",
            option1: "Salvar Anexos",
            option2: "Formato de conversação",
            option2Tips: "As citações serão removidas quando ativadas.",
            option3: "Salvar somente a última mensagem",
        },
        failedFilesPopup: {
            title: 'Exibir arquivos com falha: {num}',
            exportExcel: 'Exportar para Excel',
            retrySucTip: '{num} itens foram adicionados à lista de novas tentativas.',
        },
        viewLogsPopup: {
            title: 'Detalhes da tarefa:',
            titleRe: 'Detalhes da restauração:',
            errorNum: 'Número de falhas',
            addNum: 'Adicionar arquivo',
            updateNum: 'Modificar arquivo',
            deleteNum: 'Excluir arquivo',
            syncSize: 'Tamanho da sincronização',
            syncTime: 'Hora da sincronização',
            backupNum: 'Número de backups',
            backupSize: 'Tamanho do backup',
            backupTime: 'Hora do backup',
            tranNum: 'Número de transferências',
            tranSize: 'amanho da transferência',
            tranTime: 'Hora da transferência',
            from: 'Source:',
            to: 'Target:',
            executeTime: 'Hora da execução:',
            sourceAccount:'Conta de origem',
            targetAccounts:'Conta de destino',
            executeResult: 'Resultado da execução',
            add: 'Adicionar:',
            update: 'Atualizar:',
            delete: 'Excluir:',
        },
        taskProgressPopup: {
            title1: 'Você é um usuário premium e agora tem 10 threads para transferir arquivos simultaneamente.',
            title2: 'Atualize para qualquer serviço premium para ter no máximo 10!',
            btnTip: 'A partir de R$ 9,99',
        },
        subfileSelectPopup: {
            title: 'Selecionar conteúdo para upload',
        },
        deleteBatchPopup: {
            tips1: 'Tem certeza de que deseja excluir estas <span>{num}</span> tarefas?',
            tips2: 'Depois de excluídas, as tarefas não poderão ser recuperadas.',
        },
        freeSaledPopup: {
            tips1: 'Faça Backup De Forma Mais Inteligente Neste World Backup Day – Aproveite 50 GB Grátis De Transferência Entre Nuvens!',
            tips2: 'Espere!',
            tips3: 'Parece que você está prestes a perder seu presente do World Backup Day. Apenas um lembrete: depois de ignorado, ele desaparece para sempre!',
            btns1: 'Resgatar 50 GB',
            btns2: 'Não, obrigado',
            success: 'Parabéns! Você acabou de receber 50 GB de tráfego de transferência entre nuvens.',
            floatTitle: '50GB GRÁTIS',
            popupTitle: '<span>50GB</span> GRÁTIS',
        }
    },
    addCloud: {
        connectDesc: 'Clique na unidade de nuvem para conectá-la ao MultCloud',
        box: 'box',
        boxBusiness:'box for Business',
        dropbox: 'Dropbox',
        google_drive: 'Google Drive',
        google_drive_sharedWithMe: 'Compartilhados comigo',
        google_drive_v2: 'Google Drive',
        google_drive_shared_v2: 'Compartilhados comigo',
        oneDrive: 'OneDrive',
        oneDriveV2: 'OneDrive',
        sugarSync: 'SugarSync',
        amazonS3: 'Amazon S3',
        iDrivee2: 'IDrive® e2',
        wasabi:'Wasabi',
        webDav: 'WebDAV',
        FTP: 'FTP',
        cloudMe: 'CloudMe',
        cubby: 'Cubby',
        myDrive: 'MyDrive',
        yandex: 'Yandex',
        hiDrive: 'HiDrive',
        WEBDE: 'WEB.DE',
        baiDu: 'BaiDu',
        NAS: 'NAS',
        amazon: 'Amazon',
        alfresco: 'Alfresco',
        aDrive: 'ADrive',
        Icedrive: 'Icedrive',
        oneDrive4Business: 'OneDrive for Business',
        dropbox4Business: 'Dropbox Business',
        pCloud: 'pCloud',
        mega: 'MEGA',
        backblaze: 'Backblaze',
        putio: 'Putio',
        googlePhotos: 'Google Fotos',
        googlePhotosV2: 'Google Fotos',
        gSuiteSharedDrive: 'Drives compartilhados',
        evernote: 'Evernote',
        flickr: 'Flickr',
        mediafire: 'MediaFire',
        ownCloud: 'ownCloud',
        mySQL: 'MySQL',
        gSuite: 'Google Workspace',
        hubiC: 'hubiC',
        egnyte: 'Egnyte',
        youtube1: 'youtube1',
        facebook: 'facebook',
        picasa: 'picasa',
        goDaddy: 'goDaddy',
        ubuntu: 'ubuntu',
        welcomeTo: 'Bem-vindo ao MultCloud',
        peCloud:'Nuvens pessoais',
        buCloud:'Nuvens empresariais',
        welcomeFont: 'Agora você pode facilmente transferir e gerenciar seus múltiplos arquivos na nuvem com um aplicativo.Para começar, conecte sua nuvem ao MultCloud.',
        sharePointOnline:"SharePoint Online",
        iCloudPhotos: 'iCloud Fotos',
        gmail: 'Gmail',
        comingSoon: 'Em breve...',
        iCloudDrive: 'iCloud Drive',
        signInWith: 'Entrar com',
        outlook: 'Outlook',
        fourShared: '4shared',
    },
    addEmail: {
        connectDesc: 'Clique no e-mail para conectá-lo à MultCloud',
        peEmail: 'Selecione e faça login com o e-mail',
        iCloudNotice: 'O iCloud Drive está temporariamente indisponível para conexão, e nossa equipe de desenvolvimento está trabalhando para resolver o problema.',
        iCloudPhotosNotice: 'O Fotos do iCloud está temporariamente indisponível para conexão, e nossa equipe de desenvolvimento está trabalhando para resolver o problema.',
    },
    cloudExploer: {
        uploadFile: 'Subir Arquivo',
        newFolder: 'Nova Pasta',
        newAlbum: 'Novo álbum',
    search: 'Procurar',
        grid: 'Rede',
        pageList: 'Lista',
        reFresh: 'Atualizar',
        modified: 'Modificado em',
        openWith: 'Abrir com',
        officeOnline: 'Microsoft Office Online',
        loading: 'Aguarde,carregando…',
        uploadFolder: 'Carregar Pasta',
        trash: 'Lixo',
        recentlyDeleted: 'Excluídos recentemente',
        jumpTo: 'Pule para',
        deleteForever: 'Apagar para sempre',
        restore: 'Restaurar',
        back: 'De volta',
        searchResult: 'Resultado da pesquisa',
        emptyTrash: 'Lixo vazio',
        recoverAll: 'Recuperar tudo',
        deleteAll: 'Excluir tudo',
        fileExists: 'O arquivo existe',
        chooseOption: 'O arquivo existe, escolha uma opção!',
        needRestore: 'Para visualizar esta pasta, você precisará restaurá-la do lixo',
        limitBoxTip: '1.Algumas unidades de nuvem podem ter algumas limitações. Por exemplo, o Box não suporta transmissão de arquivo único com mais de 2 GB. Para mais informações,<a href="https://www.multcloud.com/help/limitations.html" target="_blank" class="add-cloud-link">click here</a>.<br>2. Se suas tarefas ainda não obtiverem 10 threads após a atualização para premium, cancele e transfira novamente as tarefas. Suas tarefas terão 10 threads para transferir com servidores exclusivos vip.',
        fileNameNotEmpty: 'O nome do arquivo digitado não pode estar vazio.',
        notContainSpecialChar: 'O nome do arquivo não pode conter caracteres especiais `/ \ | : * ? " < >`.',
        CharacterLimit:'O nome do arquivo não pode conter caracteres especiais `~"# %& *: < >？ / \ { | }.`',
        pathNotExist: 'O caminho não existe',
        emptyNotice: 'Esta pasta está vazia',
        trashEmpty: 'A lixeira está vazia',
        searchEmpty: 'Os resultados da pesquisa estão vazios',
        uploadSize: 'O tamanho total de uma tarefa de upload não pode ser maior que 1 GB.',
        simultaneous: 'Você pode adicionar no máximo 200 tarefas simultaneamente.',
        cancelFailed: 'O cancelamento falhou, a tarefa está sendo criada, tente novamente mais tarde',
        notWith: 'Os nomes dos arquivos e pastas não podem começar ou terminar com "."',
        notUpload: 'upload falhou.',
        duplicatePhoto: 'Fotografia duplicada. A fotografia que está a tentar carregar é um duplicado e não foi importada para a biblioteca.',
        dataLoaded: 'Dados carregados',
        sharedDate:'Data compartilhada',
        failedRestore: 'Falha ao restaurar o arquivo, porque o diretório de destino contém um arquivo com o mesmo nome.',
        //2020-12-11 lijimin
        uploadError:'Ce fichier est interdit de téléchargement (par le service cloud officiel).',
        downloadLimit: 'O limite de downloads para hoje foi atingido. Por favor, tente novamente amanhã.',
        //2022-4-26 wt
        newBucket:'Novo bucket',
        createBucket:'O nome do bucket deve conter apenas letras minúsculas e números. O comprimento deve ser de 3-63 caracteres. p.s. O nome do bucket não deve conter todos os números (como"12345678")',
        deleteBucket:'MultCloud não pode apagar bucket com uma convenção de nomes de todos os números (como "12345678").',
        getBucketObjectListFail :'MultCloud não pode listar um bucket com uma convenção de nomenclatura de todos os números(como "12345678").',
        newAlubm: '',
        specialCharError: 'O nome do arquivo não pode conter caracteres especiais `/ | : * ? " < >`.',
},
emailExploer: {
    from: 'De',
    to: 'Para',
    cc: 'cc',
    email: 'Emails',
    subject: 'Assunto',
    received: 'Tempo de recebimento',
    sentTime: 'Tempo de despacho',
    downloadMax200: 'No máximo, você pode baixar 200 e-mails por vez.',
    noSubject: '(sem assunto)',
    folderName: {
        Inbox: 'Caixa de entrada',
        Starred: 'Com estrela',
        Snoozed: 'Suspenso',
        Sent: 'Enviado',
        Drafts: 'Rascunhos',
        Important: 'Importante',
        Chats: 'Chats',
        Scheduled: 'Agendado',
        AllMail: 'Todo o correio',
        Spam: 'Spam',
        Trash: 'Lixo',
        Unread: 'Não lidas',
        Categories_Social: 'Categorias_Social',
        Categories_Updates: 'Categorias_Atualizações',
        Categories_Forums: 'Categorias_Fóruns',
        Categories_Promotions: 'Categorias_Promoções',
        Categories_Personal: 'Categorias_Pessoal',
    }
},
imageSaver: {
    analyzing: 'Analisando',
    failedToParse: 'Falha ao analisar',
    noviceGuidance: 'Você pode verificar todas as imagens/vídeos recentemente enviados para a nuvem ou imagens/vídeos empacotados para o Instagram aqui.',
    insDownloadExist: 'Você já baixou este perfil. Você pode encontrá-lo na seção "Lista de Tarefas".',
    taskExpiredOn: 'Expirado em {time}',
    taskStoringTill: 'Armazenamento até {time}',
    taskPart: 'Parte',
    taskUnitFile: 'arquivo',
    taskUnitFiles: 'arquivos',
    taskQueue: 'Em uma fila',
    taskTabUpload: 'Upload',
    taskTabSaveAll: 'Salve tudo na nuvem',
    taskTabDownload: 'Baixar tudo do IG',
    downloadInsVideo: 'Baixar o vídeo',
    downloadSinglePost: 'Baixar a publicação inteira',
    downloadAllPosts: 'Baixar todas as publicações',
    downloadAllReels: 'Baixar todos os Reels',
    downloadAllStories: 'Baixar todas as histórias',
    downloadAllHighlights: 'Baixar todos os destaques',
    saveInsVideo: 'Salvar o vídeo na nuvem',
    saveSinglePost: 'Salvar a publicação inteira na nuvem',
    saveAllPosts: 'Salvar todas as publicações na nuvem',
    saveAllReels: 'Salvar todos os Reels na nuvem',
    saveAllStories: 'Salvar todas as histórias na nuvem',
    saveAllHighlights: 'Salvar todos os destaques na nuvem',
    insCardPosts: 'publicações',
    insCardFollowers: 'seguidores',
    insCardFollowing: 'seguidos',
    insTabPosts: 'Fotos e Vídeos',
    insTabReels: 'Reels',
    insTabStories: 'Histórias',
    insTabHighlights: 'Destaques',
    insBlankText: 'Com o Instagram Downloader da MultCloud, baixe e salve facilmente posts, reels, stories e destaques do Instagram para gerenciar seu conteúdo favorito a qualquer momento.',
    webGoogleBlankText: 'Colete facilmente imagens de qualquer site ou pesquisa no Google e salve-as diretamente em seu armazenamento em nuvem ou local.',
    noTask: 'Nenhuma tarefa',
    inputTipHttp: 'Insira um URL de site ou uma palavra-chave de pesquisa no Google',
    fetchBtn: 'Buscar agora',
    fetchingBtn: 'Buscando...',
    loadMore: 'Carregue mais',
    downloadAll: 'Baixar tudo',
    saveAll: 'Salve tudo na nuvem',
    saveToCloud: 'Salvar na Nuvem',
    clearHistory: 'Apagar o histórico',
    cancel: 'Cancelar',
    retry: 'Tentar novamente',
    view: 'Visualizar',
    noImage: 'Nenhum conteúdo encontrado',
    notSupport: 'Talvez este URL não seja compatível. Por favor, verifique o URL e tente novamente.',
    inputTipIns: 'Insira um URL do Instagram',
    post: 'postagem',
    posts: 'postagemões',
    uploadTo: 'Enviar para: ',
    download: 'Download',
    uploading: 'Carregando',
    finished: 'Terminado',
    all: 'Todos',
    videoInputTip: 'Cole o link do seu vídeo aqui',
    videoTip: `Baixe vídeos em alta qualidade do YouTube, Facebook, X e mais de <a href="https://www.multcloud.com/help/video-downloader.html" target="_blank" style="text-decoration: underline;color: #5562B4;">1000 outros sites</a> 
    com o Online Video Downloader da MultCloud, sem anúncios e compatível com várias plataformas—não é necessário instalar nada.`,
    process: 'Processando...',
    thumbnail: 'Imagem de capa',
    abrTypeVeryHigh: 'Muito Alto',
    abrTypeHigh: 'Alto',
    abrTypeNormal: 'Normal',
    abrTypeLow: 'Baixo',
    default: 'Padrão',
    generat: 'Gerando arquivo',
    retryTip: 'A tarefa foi reiniciada. Você pode visualizar o progresso mais recente na aba "Todos".',
},
taskList: {
        taskListDes: 'Você pode gerenciar a transferência na nuvem, sincronização na nuvem e tarefas compartilhadas de salvamento de arquivos aqui',
        multiCloudSync: 'Sincronização de várias nuvens',
        MultiCloudTransfer: 'Transferência de várias nuvens',
        nextTransfer: 'Próxima transferência',
        scheduled: 'Programado',
        nextSync: 'Próxima sincronização',
        reTransfer: 'Transferir novamente',
        saveNow: 'Salve agora',
        transferTasks: 'Transferir tarefas',
        syncTasks: 'Sincronizar tarefas',
        shareTasks: 'Compartilhar tarefas',
        backupTasks: 'Backup tarefas',
        emailTransferTasks: 'Migração de e-mail tarefas',
        allTime: 'Tempo todo',
        today: 'Hoje',
        latestWeek: 'Semana mais recente',
        latestMonth: 'Mês mais recente',
        customDate: 'Data personalizada',
        allStatus: 'All Status',
        preset: 'Predefinição',
        noTaskCreated: 'Nenhuma tarefa foi criada',
        createTransferTask: 'Criar uma tarefa de transferência',
        createSyncTask: 'Criar uma tarefa de sincronização',
        createRemoteTask: 'Criar uma tarefa remota',
        timeMustLess: 'A hora de início deve ser menor ou igual à hora de término',
        taskNameRule: 'O nome da tarefa não pode exceder 255 caracteres',
        backupTaskNameRule:'O nome da tarefa não pode exceder 255 caracteres',
        detailNote: 'Esta tarefa ainda está sendo preparada, sem detalhes a serem mostrados.',
        notTraffic: 'Tráfego de dados insuficiente para transmissão de nuvem para nuvem.',
        reSync:'Ressincronizar',
        rebackup:'Re-backup',
        rerestore:'Restaurar',
        //2021-10-11
        createBackupTask:'Criar uma tarefa de backup',
        createTeamTransferTask:'Criar uma tarefa de transferência de equipe',
        multiClouds: 'Multi-clouds',
        speedUP: 'Acelerar',
        noTasks: 'Sem tarefas',
        noTasksTip: 'Comece sua primeira tarefa e desbloqueie a transferência e sincronização perfeitas de nuvem para nuvem.',
        loadingTip: 'Espere um segundo, por favor.',
        allTasks: 'Todas as tarefas ({num})',
    },
    cloudTransfer: {
        transferDescription: 'Configurar uma tarefa de transferência para transferir arquivos entre unidades na nuvem',
        transferOperateFrom: 'Clique aqui para selecionar as unidades ou pastas da nuvem das quais você deseja transferir',
        from: 'DE',
        to: 'PARA',
        transferOperateTo: 'Clique aqui para selecionar a unidade ou pasta da nuvem para a qual você deseja transferir',
        transferNow: 'Transferir agora',
        transfer: 'Transferir',
        addTaskOnly: 'Adicionar apenas tarefas',
        addTaskNow: 'Adicionar tarefa e transferir agora',
        addSyncTaskNow: 'Adicionar tarefa e sincronizar agora',
        addBackupTaskNow:'Adicionar tarefa e backup agora',
        transferSucces: 'Transferência bem sucedida',
        sureContinue: 'Você selecionou mais de 10 itens de origem e cada item de origem corresponde a um e-mail de notificação. Isso significa que você pode receber mais de 10 emails de notificação. Tem certeza que deseja continuar? ',
        certeza: 'Sim, tenho certeza.',
        sure: 'Sim eu tenho certeza',
        //2020-10-29ljm新增
        sourceRemind:'O número máximo de itens de origem é 200. Selecione menos itens ou selecione uma pasta inteira. P.S. Uma pasta inteira conta apenas um item.',
        backupSourceRemind:'O número máximo de itens de origem é 1000. Selecione menos itens ou selecione uma pasta inteira. P.S. Uma pasta inteira conta apenas um item.'
    },
    cloudSync: {
        syncDescription: 'Configurar uma tarefa de sincronização para sincronizar arquivos entre unidades na nuvem',
        syncOperateTo: 'Clique aqui para selecionar as unidades ou pastas da nuvem com as quais você deseja sincronizar',
        syncOperateFrom: 'Clique aqui para selecionar a unidade ou pasta da nuvem da qual você deseja sincronizar',
        syncNow: 'Sincronize Agora',
        taskEmpty: 'O nome da tarefa não pode estar vazio.',
        //2020-10-29ljm新增
        aimRemind:'O número máximo de diretórios de destino é 200.',
        realTimeSync:'Sincronização de tempo real',
        normalSync:'Sincronização normal',
        pause:'Faça uma pausa',
        paused:'Em pausa',
        swicthTwoWay:'Mude para sincronização bidirecional',
        switchOneWay:'Mude para sincronização unilateral',
        fristSync:'Primeira Sincronização',
        lastSync:'Última Sincronização',
        initSync:'A sincronização inicial de dados ainda está em andamento, aguarde.',
        realSyncing:'Sincronizando em tempo real ...',
        servicesSu:'Serviços em nuvem com suporte para sincronização em tempo real',
        addRealDrives:'Você deve adicionar uma unidade de nuvem que suporte sincronização em tempo real.',
        egDrives:'Por enquanto, apenas Google Drive, Dropbox, Dropbox Business, OneDrive, OneDrive for Business, G Suite, box são compatíveis com sincronização em tempo real.',
        initTial:'Inicializando',
        createdAt:'Criado em',
        realSync:'Sincronização em tempo real',
        oneWaySimple:'Unidirecional (Sincronização Simples)',
        twoWay:'Duas vias (em breve ...)',
        gooleFolder:'Não será sincronizado se houver apenas alterações nos subdiretórios de uma pasta do Google Drive.',
        realTimeNotice:'Você pode ter até 2 tarefas de sincronização em tempo real em execução ao mesmo tempo, portanto, algumas de suas subtarefas serão pausadas. Tem certeza que deseja continuar?',
        reachMax:'Atinge o número máximo de registos, apenas o registo mais recente é mostrado.',
        notRun:'a tarefa não está funcionando.',
        bePaused:'Se a tarefa de sincronização em tempo real permanecer em estado inoperante por mais de 7 dias, ela será automaticamente pausada.',
        dontShow:'Não mostre isto novamente',
        timeOut:'Travessia expirou',
        outMostly:'A razão principal da travessia temporizador é que há muitos arquivos ou subdiretórios demais para sincronização em tempo real. Sugerimos que crie uma tarefa de sincronização normal.'
    },
    emailTransfer: {
        cloudEmail: 'Migração de e-mail',
        description: 'Migre seu e-mail para a nuvem como PDF.',
        migrationSetting: 'Configurações de migração',
        cutSetting: 'Corte - Ajustes',
        copySetting: 'Configurações de cópia',
        settingTips: '',
        notification: 'Notificaçõe',
        watermark: 'Marca d\'água',
        delWatermark: 'Remover marcas d\'água de e-mails baixados como PDF',
        saveAtt: 'Salvar Anexos',
        converFormat: 'Formato de conversação',
        converFormatTip: 'As citações serão removidas quando ativadas.',
        saveOnly: 'Salvar somente a última mensagem',
        optionTitle: 'Alguns e-mails já existem, o que você gostaria de fazer?',
        filterTitle: 'Você pode especificar um filtro adicional para a seleção FROM.',
        filterMessage: 'Favor digitar os e-mails e separá-los com vírgula',
        filterOption1: 'Sobregravá-la se a conversa tiver sido atualizada',
        filterOption2: 'Sempre pular',
        filterOption3: 'Sempre renomear',
        filterOption4: 'Com anexo',
        filterOption5: 'Não lido',
        transferNow: 'Migrar agora',
        filterDateOptions1: 'Qualquer altura',
        filterDateOptions2: 'Com mais de uma semana',
        filterDateOptions3: 'Com mais de um mês',
        filterDateOptions4: 'Com mais de 6 meses',
        filterDateOptions5: 'Com mais de um ano',
        filterDateOptions6: 'Intervalo personalizado...',
        showMore: 'Mostrar mais',
        startDate: 'Data de início',
        endDate: 'Data de final',
    },
    exception: {
        exceedMaxLimit: 'O número de pedidos excedeu o máximo.',
        addCloudFailed: 'Alguns parâmetros não foram inseridos corretamente.',
        cloudNameExist: 'Este nome de exibição já existe, digite outro.',
        pathNotFound: 'Verifique se existe arquivo ou pasta pelo caminho especificado.',
        notBeTheSame: 'A pasta de origem e a pasta de destino não poderiam ser as mesmas.',
        notTransferring: 'Este diretório não pode ser selecionado para transferir arquivos, selecione seus subdiretórios ou outros diretórios.',
        verifyCodeInvalid: 'Erro no código de verificação.',
        nameEmpty: 'O nome de exibição não pode estar vazio',
        emailEmpty: 'O email não pode estar vazio',
        serverEmpty: 'o servidor não pode estar vazio',
        usernameEmpty: 'O nome do usuário não pode estar vazio',
        passwordEmpty: 'A senha não pode estar vazia',
        domainEmpty: 'O domínio não pode estar vazio',
        bucketNameEmpty: 'O nome do balde não pode estar vazio',
        accessKeyEmpty: 'O ID da chave de acesso não pode estar vazio',
        secretAccessKeyEmpty: 'Chave de acesso secreta não pode estar vazia',
        keyIdEmpty: 'keyID não pode estar vazio',
        applicationKeyEmpty: 'applicationKey não pode estar vazio',
        sugarSyncWarn: 'Não há suporte para selecionar o diretório, selecione o diretório "Web Archive", "Magic Briefcase", "Mobile Photos", suas subpastas ou outros diretórios.',
        flickWarn: 'Copiando para o diretório selecionado não é suportado, selecionar o diretório do "/ álbuns".',
        baiDuWarn: 'Copiando para o diretório selecionado não é suportado, selecionar o diretório "全部文件/我的应用数据/MultCloud".',
        dropBoxbusinessWarn: 'Copiando para o diretório raiz não é suportado, selecionar outro diretório.',
        notMediaFiles: 'Nota: O diretório "Álbuns" pode armazenar apenas diretórios de álbuns, mas não arquivos de mídia.',
        notStoreDirectories: 'O diretório "Fotos" não pode armazenar diretórios.',
        onlyStoreImages: 'Nota: O diretório "Fotos" pode armazenar apenas imagens, vídeos e outros arquivos de mídia, mas não os diretórios',
        unknownError: 'Falha na conexão com este serviço. Reautorize o acesso do MultCloud ao serviço.',
        renameCloudFailed: 'Falha ao renomear a nuvem, tente novamente mais tarde.',
        deleteCloudFailed: 'Falha ao excluir a nuvem, tente novamente mais tarde.',
        invalidCloudAccount: 'Esta conta na nuvem não existe.',
        bindEmailFail: 'Falha ao vincular o email.',
        linkHasExpired: 'O link expirou.',
        listItemsFailed: 'Falha ao listar arquivos, adicione novamente a nuvem ao MultCloud.',
        deleteItemFailed: 'Falha ao excluir o item.',
        renameItemFailed: 'Falha ao renomear o item.',
        createFolderFailed: 'Falha ao criar pasta.',
        moveItemFailed: 'Falha ao mover o item.',
        shareItemFailed: 'Falha ao compartilhar o item.',
        uploadFailed: 'Dados do arquivo não encontrados.',
        toFolderIdBlanked: 'O "tid" está em branco',
        downloadFileFailed: 'Falha ao baixar o arquivo, atualize a página ou adicione novamente a nuvem ao MultCloud.',
        addTaskFail: 'Falha ao adicionar tarefa.',
        taskQuotaLimit: 'Você atingiu o número máximo de 1000 tarefas de transferência de nuvem para nuvem. Exclua algumas tarefas sem importância.',
        deleteTaskFail: 'Falha ao excluir a tarefa.',
        maxRunningLimit: 'A tarefa em execução excede o número máximo e esta tarefa pode ser adicionada como aguardando',
        userCreateFail: 'Falha ao criar usuário, tente novamente mais tarde.',
        userUpdateFail: 'Falha ao modificar as informações da conta, atualize a página e tente novamente.',
        createSaltFail: 'Falha ao criar sal, tente novamente.',
        listFolderFailed: 'Falha ao listar a pasta, tente adicionar novamente a nuvem.',
        cloudCategoryInvalid: 'O serviço em nuvem já não é mais suportado.',
        executeTaskFail: 'Falha ao executar a tarefa, verifique sua conexão com a web.',
        parameterInvalid: 'Os parâmetros são inválidos',
        saltInvalid: 'Sua sessão expirou, faça o login novamente.',
        emailInvalid: 'Não é um email válido.',
        notAuthorized: 'O nome de usuário ou senha não está correto.',
        cloudNameEmpty: 'O nome de exibição não pode estar vazio.',
        addCloudExpired: 'Falha ao adicionar nuvem, adicione novamente o serviço de nuvem.',
        verifyCodeInvalid: 'O código de verificação é inválido.',
        emailExist: 'O e-mail já existe.',
        exceedMaxLimit: 'Os pedidos excedem o número máximo.',
        userIdNotNull: 'O ID do usuário é nulo',
        notFoundTask: 'A tarefa não foi encontrada.',
        noTaskRunning: 'Nenhuma tarefa está sendo executada',
        userNotFound: 'O usuário não foi encontrado.',
        loginerNotFound: 'O loginer não é suportado',
        deletePermissionLimited:'Você não pode prosseguir com esta operação, porque você não tem "Permissão de apagamento"',
        notHaveDeletePermission: 'Você não tem permissão para excluir o arquivo/pasta.',
        uploadPermissionLimited:'Você não pode prosseguir com esta operação, porque não tem "Permissão de upload"',
        movePermissionLimited:'Você não pode prosseguir esta operação, porque não tem "permissão de movimento".',
        copyPermissionLimited:'Você não pode prosseguir esta operação, porque não tem "permissão de cópia".',
        notHavePermission: 'Devido à falta de permissão de gravação, você não pode colar este arquivo/pasta.',
        mkdirPermissionLimited:'Você não pode prosseguir com esta operação, porque você não tem "Permissão de criação de pastas"',
        notCreatPermission: 'Você não pode criar um bucket ou pasta devido à falta de permissão de gravação ou espaço insuficiente.',
        renamePermissionLimited:'Você não pode prosseguir com esta operação, porque você não tem "Permissão de renomeação"',
        creatIDriveFolderError: 'O nome do objeto contém caracteres não suportados.',
        creatIDriveFolderToLong: 'O nome da pasta não pode exceder 245 caracteres.',
        noUploadPermission: 'Devido à falta de permissões de upload ou espaço de armazenamento insuficiente na nuvem, você não pode fazer upload deste arquivo.',
        bucketNameLongError: 'Os nomes dos buckets devem ter de 3 a 63 caracteres, usar apenas letras minúsculas, números, pontos (.) e hífens (-), começar e terminar com uma letra ou número e evitar pontos consecutivos.',
        bucketNameIsNotIp: 'O nome do bucket não pode ser um endereço IP.',
        downloadPermissionLimited:'Você não pode prosseguir com esta operação, porque você não tem "Permissão de download"',
        ipNotFound: 'O ip não foi encontrado',
        onlyAlbum: 'Apenas os diretórios de álbuns criados ou compartilhados pelo MultCloud podem ser selecionados para armazenar imagens, vídeos e outros arquivos de mídia.',
        createFolderFail: 'Falha ao criar a pasta',
        parametersNotEmpty: 'Os parâmetros não devem estar vazios.',
        //mega报错
        addMegaFailed: 'Alguns parâmetros não foram inseridos corretamente ou você ativou F2A.',
        //mySql报错
        mySqlWarn:'Esta nuvem não pode ser selecionada como o destino da transferência de nuvem para nuvem.',
        //2020-10-29ljm新增
        maxTaskRemind:'Você atingiu o número máximo de 5.000 tarefas de transferência / sincronização em nuvem. Exclua algumas tarefas desnecessárias e tente novamente. P.S. Se houver 3 fontes em uma tarefa de transferência, a tarefa de transferência contará como 3 tarefas.',
		// 2020-11-25 yjs
        torrentTort:'Este conteúdo é copiado não autorizado ou infringente.',
        //2020-12-4 xth
        shareNotUpload:'O proprietário cancelou \"permitir o upload\" permissão, por favor atualize a página.',
        //2020-12-9 xth
        shareItemUpdate:'O proprietário alterou a permissão deste link de compartilhamento, atualize a página.',
        nameLong:'O nome do usuário não pode exceder 20 caracteres.',
        notPermission:'Este é um arquivo de equipe e você não tem permissão para executar essa operação.',
        notOpened:'Esta nuvem não suporta sincronização em tempo real.',
        taskNotFound:'A tarefa não existe.',
        subscribeFail:'Falha ao criar tarefa.',
        driveAccountIdInvalid:'Não é possível criar a tarefa de sincronização em tempo real. Remova e adicione novamente os serviços em nuvem selecionados e tente novamente.',
        unknownState:'Não é possível executar esta operação, tente novamente mais tarde.',
        InvalidParameter:'Parâmetro inválido.',
        InvalidDirectory:'O diretório raiz do box não suporta esse recurso.',
        HasExist:'A tarefa de sincronização instantânea para esta pasta já existe, cancele a tarefa de sincronização instantânea para esta pasta e recrie-a na pasta',
        // taskRunningNumberLimited:'Você pode executar 5 tarefas nuvem a nuvem em paralelo, por favor, cancele uma tarefa em execução e tente novamente.',
        taskRunningNumberLimited:'Já existem 2 tarefas de sincronização em tempo real no status de execução e, primeiro, pause uma tarefa de sincronização em tempo real.',
        reachedLimit:'Você atingiu o limite de taxa desta nuvem, tente novamente mais tarde.',
        selectAlbumWarn:'Nota: Um diretório de álbum só pode armazenar imagens, vídeos e outros arquivos de mídia, mas não diretórios.',
        notSupported:'A sincronização em tempo real não é compatível com tarefas de múltiplos alvos por enquanto.',
        incorrectFormat:'Desculpe, o formato do seu número de telefone está incorreto',
        taskMaximumNumberLimited:'Você atingiu o número máximo de 200 tarefas de sincronização em tempo real. Exclua algumas tarefas de sincronização em tempo real desnecessárias e tente novamente.',
        autoLoginFail:'Você ativou a verificação em duas etapas. Faça login novamente.',
        unsubscribeFail:'falha de cancelamento de inscrição',
        //云盘操作报错
        alreadyAdd:'Já adicionou a nuvem.',
        toggleWhileEditing:'A conta que você adicionou não corresponde à conta atual.',
        unsubscribeFail:'falha de cancelamento de inscrição',
        //2022-4-25 wt
        emptyBucket:'Você não pode apagar buckets que não estejam vazios. P.S. Por favor, verifique se também não há objetos na versão de bucket do Wasabi.',
        cannotCopyFolder:'Você não pode  copiar uma pasta para o mesmo bucket.',
        cannotCopyIdrivee2Folder: 'Pastas na mesma conta Idrive e2 não podem ser copiadas entre si.',
        cannotCutFolder:'As pastas no mesmo intervalo não podem ser recortadas e coladas umas nas outras.',
        bucketAlreadyExists:'O nome do bucket solicitado não está disponível. O espaço de nomes do bucket é compartilhado por todos os usuários do sistema. Por favor, selecione um nome diferente e tente novamente.',
        accessPermissionLimited:'Você não tem permissão de acesso a esta pasta.',
        accessDenied:'Acesso rejeitado, você não está autorizado a realizar esta operação.',
        shareTransferCanotCopy: 'No momento, não é possível copiar a pasta raiz de um compartilhamento de múltiplos itens.',
        // 2022-06-08 wt
        sharePointOnlineNotTrans:'O diretório raiz de SharePoint não pode ser selecionado para a transferência de arquivos, favor selecionar um subdiretório de um site.',
        sharePointListFailed:'Error 500: InternalServerError. Dica: Verifique se esta conta tem acesso ao serviço SharePoint.',
        sameDirError: 'As contas de origem e as contas de destino não são as mesmas.',
        
        accessDenied:'Acesso negado',
        //iCloudPhotos报错
        onlySaveAlbums: 'Nota: O diretório de destino que você selecionar só pode salvar álbuns (pastas).',
        notSelectICloudPhotosRoot: 'Nota: O diretório raiz do iCloud Photos só pode salvar álbuns (pastas).',
        notSelectICloudPhotosForder: 'Nota: O diretório de destino que você selecionar só pode salvar álbuns (pastas).',
        notSelectICloudPhotosAlbum: 'Nota: O diretório de destino selecionado só pode salvar imagens (pastas não disponíveis).',
        notSelectICloudPhotosOther: 'Nota: O diretório de destino selecionado não pode salvar imagens diretamente, todas as imagens transferidas serão salvas na pasta "Recentes".',
        notSelectICloudPhotosBackup: 'iCloud Photos não pode ser selecionado como alvo para o "Cloud Backup". Para salvar imagens em iCloud Photos, selecione "Cloud Transfer" ou "Cloud Sync".',
        notSelectICloudPhotosSyncRoot: 'Nota: Não é possível sincronizar imagens com o diretório raiz do iCloud Photos.',
        notSelectICloudPhotosSync: 'Esta é uma pasta em iCloud Photos, você só pode sincronizar imagens com álbuns em iCloud Photos.',
        sendTooMany: 'Foram enviados muitos códigos de verificação. Digite o último código recebido, use um de seus dispositivos ou tente novamente mais tarde.',
        verifySecurityCodeFailed: 'Falha na verificação, favor verificar e digitar novamente o código de verificação.',
        appleNotEnablePhotos: 'Fotografias em iCloud não está disponível para o seu ID Apple. Para utilizar Fotografias em iCloud, inicie sessão com um ID Apple que utiliza num dispositivo Apple.',
        tooManyRequests429: 'Limite de taxa de usuário excedido. Tente novamente após {date}.',
        tooManyRequests403: 'Muitos pedidos ao mesmo tempo, tente novamente mais tarde.',
        // iCloudDrive报错
        folderNameIsTooLong: 'O nome da pasta não pode exceder 255 caracteres.',
        fileNameIsTooLong: 'O nome do arquivo não pode exceder 250 caracteres.',
        iCloudDriveNotEnoughSpace: 'Não há espaço suficiente para carregar o arquivo.',
        uploadFileIsTooBig: 'O arquivo é muito grande para carregar. Atualmente, o MultCloud limita os uploads a um máximo de 100 MB.',
        uploudFileSizeIsZero: 'Não é possível carregar ficheiros com zero bytes para o iCloud Drive.',
        notUploudSpecialFile: 'Não é possível enviar ficheiros deste tipo para a biblioteca desta app.',
        notRenameApp: 'A Apple não permite renomear as pastas de aplicativos, como Pages, Numbers e Keynote.',
        ErrorDeleteDistinguishedFolder: 'Pastas distintas não podem ser excluídas.',
        moreThan256Characters: 'O nome da pasta não pode exceder 256 caracteres.',
        cloudNotFound: 'A nuvem foi removida.',
        fourSharedUnauthorized:' Sua autorização 4shared expirou. Reautorize sua conta clicando em "Adicionar novamente".',
        fileFolderNameLengthExceed:"O comprimento do nome do arquivo/pasta não pode exceder 255 caracteres.",
        invalidLink: 'Link inválido.',
        requestFailed: 'O pedido não foi bem-sucedido.',
        exceeds2GB: 'O tamanho do arquivo excede 2 GB e não pode ser baixado.',
        licenseUpgradError: 'A licença não está disponível, pois você é um {scheme} assinante',
        noLicenseCode: 'Por favor, insira um código de licença',
        licenseCodeError: 'O código de licença que você inseriu está incorreto',
    },
    preview: {
        fileNotReview: 'arquivos não podem ser revisados',
        goOringinalSite: 'Ir para o site original'
    },
    remoteTask: {
        remoteTask: 'Tarefa remota',
        createTask: 'Criar Tarefa',
        successsExceed: 'Link copiado!',
        operateSuccess: 'Operar o Sucesso',
        noRemote: 'Nenhuma tarefa remota foi criada',
        unKnownError: 'Um erro desconhecido',
		undefinedDisk:"Não é possível encontrar o diretório de destino, copie o link de download e crie uma nova tarefa de upload remoto",
		taskExpired:'Tarefa expirada, crie uma nova tarefa',
		createDescribe:'Transfira arquivos de links, torrents, ímãs diretamente para suas nuvens',
		excuteNow:'Execute agora',
		noSeeds:'Baixo recurso',
		failedToParse:'Falha ao analisar.',
		parseMagnetRunning:'Analisar sementes, por favor, aguarde......',
        selectedFileLimit:'O número de arquivos selecionados não pode exceder 500 e o tamanho total não pode exceder 50 GB.',
        addLink: 'Adicionar link',
        startEmailSend: 'Enviar notificação por email ao concluir esta tarefa.',
        nowUpload: 'Carregar agora',
    },
    shares: {
        myShares: 'Minhas Ações',
        savedShares: 'Compartilhamentos Salvos',
        sharedOn: 'Compartilhado em',
        allowedTo: 'Permitir upload',
        location: 'Localização',
        shareNull: 'Você ainda não compartilhou nenhum arquivo.',
        shareNullTips: 'Dicas: Para compartilhar um arquivo, basta clicar com o botão direito no arquivo e selecionar a opção “Compartilhar”.',
        savedShareNull: 'Você ainda não salvou nenhum arquivo compartilhado.',
        savedShareNullTips: 'Dicas: Se alguém compartilhar um link de compartilhamento com você, você pode salvá-lo aqui para acesso rápido.',
    },
    login: {
        experienceSigning: 'Experiência sem assinatura',
        forgotPassword: 'Esquece-se da senha?',
        signIn: 'Assinar em',
        rememberMe: 'Lembre de mim',
        keepLogin: 'Manter-se conectado',
        loginWith: 'Entrar com',
        email: 'Email',
        password: 'Senha',
        verificationCode: 'Código de Verificação',
        firstName: 'Primeiro Nome',
        lastName: 'Último Nome',
        confirmPassword: 'Confirme a Senha',
        createAccount: 'Criar Conta',
        continueWith: ' ou continue com',
        resetMessage: 'Enviar Mensagem de Redefinição',
        enterEmail: 'Digite o endereço de e-mail com o qual você se inscreveu abaixo. Um email será enviado contendo um link para redefinir sua senha.',
        enterCorrectEmai: 'Digite o formato correto do endereço de e-mail.',
        passwordCharacters: 'A senha deve ter 8-16 caracteres',
        passwordDiff: 'As duas senhas inseridas são inconsistentes',
        enterCode: 'Por favor, insira o código de verificação.',
        sentSuccess: 'O email foi enviado com sucesso.',
        successfully: 'Inscreva-se com sucesso',
        pleaseEmail: 'Por favor introduza o seu e-mail',
        pleasePassword: 'Por favor, insira sua senha',
        accountActivated: 'Sua conta não foi ativada.',
        enterCorrectPass: 'Digite o endereço de e-mail correto ou o nome e a senha temporários da conta.',
        resetPasseord: 'Para proteger sua conta, clique em “Esqueceu a senha” redefinir sua senha.',
        validEmail: 'Por favor digite um email válido',
        enterFirstName: 'Por favor entre com seu primeiro nome.',
        enterLastName: 'Por favor insira seu sobrenome.',
        reEnterPass: 'Por favor digite sua senha novamente.',
        creatingAccount: 'Ao criar uma conta, você concorda com o',
        termsUse: 'Termos de Uso',
        privacyPolicy: 'Política de Privacidade',
        thankYou: 'Obrigado!',
        checkEmail: 'Por favor verifique seu email',
        confirmRegistration: 'para confirmar seu registro. Você pode pular o processo de ativação e usar nosso produto normalmente, mas se você esquecer sua senha, não podemos ajudá-lo a recuperá-la.',
        noteReceiveEmail: 'Não recebeu email?',
        receiveConfirmationEmail: 'Se você não recebeu um email de confirmação, envie um email para',
        buttonResend: 'ou clique no botão para reenviar.',
        forgetEmail: 'Esqueceu seu endereço de email?',
        sendEmailSupport: ' Envie um email para suporte',
        trackDown: 'e vamos rastrear.',
        passwordnotMatch: 'A senha que você digitou não confere',
        enterVaildPassWord: 'Por favor, digite uma senha válida',
        usernameNotContain: 'O nome de usuário não pode conter caracteres especiais.',
        updatedSuccessfully: 'Seus dados foram atualizados com sucesso',
        thankBindEmail: 'Obrigado por vincular o endereço de e-mail, verifique o e-mail de ativação a tempo',
        failExceedOperation: 'Falha ao exceder esta operação',
        enterNewPassword: 'Por favor, digite a nova senha',
        ConfirmaçãoPassword: 'Por favor, digite a senha de confirmação',
        userNameNot: 'nome de usuário não pode estar vazio',
        //login popup用
        signUp: 'Inscrever-se',
        logInButton: 'Conecte-se',
        logInWith: 'Entrar com',
        logToMultCloud: 'Entrar no MultCloud',
        logEmailInput: 'Email / nome da conta temporária',
        verificationIncorrect: 'A verificação que você inseriu está incorreta.',
        signUpTitle: 'Sign e obter tráfego de dados gratuito de 5GB todos os meses',
        title: "Transferi-lo para seus serviços de nuvem com MultCloud.",
        tips: "Já tem uma conta?",
        tips2: "Não tem uma conta?",
        btnTxt: "está fazendo login... ",
        facebook: "Facebook",
        google: "Google",

        exception: {
            strEmpty: "Por favor, preencha este campo",
            nameToLong: "Seu nome de usuário deve conter de 1 a 20 dígitos",
            emailError: "Digite um endereço de e-mail válido, por favor,",
            pwdError: "Digite uma senha com 8-16 dígitos, por favor,",
            rePsdEmpty: "Digite sua senha novamente, por favor,",
            rePwdError: "A senha não corresponde",
            codeEmpty: "Digite o código de verificação, por favor",
            codeError: "O código de verificação deve ser de 4 dígitos",
            verifyCodeInvalid: "O código de verificação não está correto",
            emailExist: "O endereço de e-mail já foi registrado"
        }
    },
    home: {
        driveNameNotContain: 'O nome do Drive não pode conter caracteres especiais `/ \ | : * ? " < >  &`.',
        cloudDiskName: 'O nome do disco na nuvem não pode exceder 200 caracteres.'
    },
    sharesPage: {
        linkFailure: 'Desculpe, este arquivo compartilhado foi cancelado.',
        linkMasking: 'Desculpe, este arquivo compartilhado foi bloqueado para visualização.',
        saveCloud: 'Salvar na nuvem',
        directDownload: 'Download direto',
        saveLink: 'Salve o link',
        cancelShare:'Cancelar compartilhamento',
        uploadFile: 'Subir arquivo',
        newFolder: 'Nova pasta',
        saveLinkSuccessBefore: 'Você salvou o link com sucesso.',
        saveLinkSuccessAfter: ' Ver os links salvos',
        saveLinkFail: 'Falha em salvar o link.',
        downloadingFolder: 'Downloading folder is not supported at present.',
        downloadingMore: 'YO download da pasta não é suportado no momento.',
        downloadingNone: 'Selecione um arquivo.',
        sharecanceledSuccess: 'Compartilhamento cancelado.',
        sharecanceledFailed: 'Falha ao cancelar compartilhamento.',
        newFolderInRoot: 'Insira subdiretórios para criar uma nova pasta.',
        uploadFileInRoot: 'Insira subdiretórios para fazer upload de um arquivo.',
        selectFileTransfer: 'Selecione um arquivo para transferir.',
        createTransferFailed: 'Falha ao criar tarefa de transferência',
        createTransferSuccessBefore: 'Você criou com sucesso uma tarefa de transferência.',
        createTransferSuccessAfter: ' Ver Tarefa',
        addCloudService: 'Adicionar serviço em nuvem',
        mustAddClouds: 'Você deve adicionar uma unidade de nuvem válida',
        selectSaveCloudTitle: 'Por favor selecione',
        moreClouds:'Mais nuvens',
        saveLinkExists: 'O link já existe.',
        errorShare404: 'Arquivo fonte não encontrado.',
        passWordError: 'Senha incorreta!',
        passWordNone: 'A senha não deve estar vazia.',
        passWordInputTitle: 'Arquivo de compartilhamento privado MultCloud',
        passWordInputMsg: 'Por favor insira a senha.',
        passWordInputButton: 'OK',
        loginErrorMax: 'Você não atualizou sua senha por muito tempo, atualize sua senha.',
        uploadFolder: 'Você só pode fazer upload de arquivos no momento.',
        pleaseSignIn: 'Entre em MultCloud, por favor.',
    },
    share:{
        noManageMyShare: "Você pode gerenciar todos os seus arquivos compartilhados aqui.",
        noManageSavedShare: "Você pode gerenciar todos os compartilhamentos salvos aqui.",
        unknownError: "O arquivo de compartilhamento está faltando, ele pode ser movido ou excluído.",
        privateShareText: "(Entre em contato comigo para obter a senha)",
    },
    inviteFriends:{
        titleBefor: 'Convide quantos amigos você puder e obtenha ',
        titleAfter: ' de tráfego para cada amigo que você convidou! Sem limite de cota!',
        shareEmailTitle: 'Convite para compartilhar: ',
        shareLinkTitle: 'Compartilhar link de convite: ',
        emailSend: 'Enviar',
        emailTip: 'Adicione o endereço de e-mail aqui',
        wonMonthFlows: 'Tráfego adicional vitalício que você ganhou neste mês: ',
        wonMonthTitle: 'Tenha a chance de ganhar tráfego de dados ILIMITADO PARA TODA A VIDA!',
        lastWinner: 'Último Vencedor ',
        winnerInvites: 'Com {num} convites',
        winnerTip: 'Ganhou LIFETIME UNLMITED',
        statusTitle: 'Seu status de compartilhamento',
        successInvites: 'Convites bem-sucedidos este mês: ',
        chanceWin: 'Chance de ganhar: ',
        tipsTitle: 'Termos',
        tipsOne: 'Somente usuários convidados com um e-mail verificado contam como um convite bem-sucedido.',
        tipsTwo: 'Sem limite de cota para o tráfego que você ganha ao convidar pessoas.',
        tipsThird: 'Se você já é um assinante de tráfego ilimitado, não pode ganhar 2 GB de um convite bem-sucedido, mas sua chance de ganhar o serviço Life-time Unlimited será duplicada.',
        shareText: 'MultCloud - Transfira e gerencie seus vários arquivos em nuvem com um aplicativo. Junte-se ao MultCloud hoje e ganhe um bônus de tráfego de nuvem para nuvem de 2 GB!',
    },
    paySystem:{
        billed:'Faturado a $ 0,099 / GB para tráfego adicional',
        subCould:'Os assinantes podem usar 50 GB / $ 5,9 e 100 GB / $ 9,9 para tráfego de dados adicional se o tráfego de dados não for suficiente',
        limitedMonth:'150 GB/mês',
        limitedTrafficMonth:'150GB Trânsito/mês',
        unlimitedTraffic:'Tráfego ilimitado para toda a vida!',
        foraYear:'Tráfego ilimitado por um ano',
        noNeedPurchase:'Não há necessidade de adquirir tráfego adicional',
        yearlyPayment:'Pagamento anual (R$41,67/mês)',
        validityData:'A validade do tráfego de dados que você compra é permanente',
        additionalPackage:'Pacote de tráfego adicional',
        subscriptmc:'Sua assinatura do MultCloud',
        upgradeMore:'Atualize para o MultCloud Premium para obter mais tráfego de transferência e benefícios extras',
        recommended:'Recomendado',
        toUnlimited:'Atualize para ilimitado',
        otherPlan:'Outros planos',
        moreTraffic:'Compre mais tráfego',
        quarterlySubscriber:`Você é um assinante mensal e tem 150 GB de tráfego de dados para transferir ou sincronizar dados entre o armazenamento em nuvem <br> serviços todos os meses.`,
        moreDetails:`<a class='add-cloud-link sysLink'>Mais detalhes sobre os privilégios >></a>`,
        dataTraffic:'Uso de tráfego de dados do mês atual',
        cloudTraffic:'Tráfego de nuvem para nuvem',
        buyNow:'Compre Agora',
        specialOffer:'Oferta especial',
        lifetimeFree:'Lifetime Free',
        unsubscribe:'Cancelar subscrição',
        includes:'Inclui',
        reSubscription:'Reativar assinatura',
        monthTraffic:'Tráfego ilimitado por um mês',
        threeMonth:'30 GB / mês',
        monthlyPayment:'Pagamento mensal',
        monthlyUnlimited:'Mensal ilimitado',
        gb:'GB',
        YearlyUnlimited:'Anual Ilimitado',
        YearlyPaymentNine:'Pagamento anual (R$54,99/mês)',
        Onetime:'Pagamento Único',
        twoMonthree:'200 GB / mês x3',
        QuarterlyPayment:'Pagamento Trimestral (R$46,66/Mês)',
        fourMOne:'400 GB / mês x12',
        quarterlySubscriber:`Você é um assinante trimestral e tem 200 GB de tráfego de dados para transferir ou sincronizar dados entre os serviços de armazenamento em nuvem todos os meses.`,
        yearlySubscriber:`Você é um assinante anual e tem 400 GB de tráfego de dados para transferir ou sincronizar dados entre os serviços de armazenamento em nuvem todos os meses.`,
        expireIn:'Expira em',
        billYearly:'Faturado anualmente',
        billMonthly:'Faturado Mensalmente',
        billQuarterly:'Faturado Trimestralmente',
        twoMonTrafficthree:'200GB Trânsito/mês x3',
        fourMTrafficOne:'400GB Trânsito/mês x12',
        deleteSubAccount:'Você tem que cancelar a inscrição para excluir sua conta, tem certeza que deseja fazer isso?',
        payFirst:'Você deve',
        paybindEmail:`<a class='add-cloud-link sysLink'> vincular seu endereço de e-mail e verificá-lo </a>`,
        payEnd:'antes de se inscrever, porque precisamos garantir que você receberá com êxito os e-mails importantes sobre sua inscrição.',
        yearlyPaymentTxt:'Pagamento anual',
        quarterlyPaymentTxt:'Pagamento Trimestral',
         //2021-5-20新加
        upUnlimited:'Atualize para Anual Ilimitado',
        payDiff:'Pague apenas a diferença de preço!',
        yearlyUnlimit:'MultCloud (<b>anual sem limites</b>)',
        providesUnlimited:'O plano Yearly Unlimited fornece tráfego de dados ilimitado para transferir ou sincronizar dados entre serviços de armazenamento em nuvem por 12 meses.',
        subProduct:'Este é um produto de assinatura com uma taxa de',
        perYear:'por ano.',
        cancelSubscription:'Você pode cancelar sua assinatura a qualquer momento.',
        defaultPayment:'O método de pagamento padrão é',
        anotherPayment:'Se desejar usar outro método de pagamento, por favor ',
        clickHere:'clique aqui',
        tryAgain:'O pagamento não pode ser feito por enquanto. Verifique sua forma de pagamento e tente novamente.',
        contactPayment:'.Tem algum problema com o pagamento? Fique à vontade para entrar em contato com <a href="mailto:support@multcloud.com">support@multcloud.com</a>',
        Notice:'Aviso',
        beforeBind:'Por favor vincule seu endereço de e-mail antes de se inscrever.',
        processorder:'Processando o Pedido',
        eachGbMoney:'R$0,66/',
        eachGbMoneyT:'R$0,54/',
        payCouponQuartly:'Quarterly Payment(R$36,66/mês)',
        payCouponlimitedYearly:'Pagamento anual(R$30,83/mês)',
        payCouponunlimitedYearly:'Pagamento anual(R$39,17/mês)',
        payCouponunlimitedYearlyLow:'Pagamento anual(R$36,67/mês)',
        tips:'Dica: Se você tiver alguma dúvida, não hesite em contactar <a href="mailto:support@multcloud.com">support@multcloud.com</a>.',
        monthly:'150 GB mensal',
        //新版付费页面
        payTitle: 'Escolha a MultCloud certa para si!',
        limitedData: 'Dados limitados',
        unlimitedData: 'Dados ilimitados',
        monthly: 'Mensalmente',
        annually: 'Anualmente',
        save58: 'Economizar até 58%',
        payTip: 'Contate com nossa equipe',
        limitTips: 'O tráfego de dados não utilizados irá acumular-se',
        unlimitTips: 'Já não se trata de limite de dados',
        tips2: 'Se encontrar algum problema durante a compra online, não hesite em contactar-nos: <a href="mailto:support@multcloud.com">support@multcloud.com</a>',
    vipUpgradeTips: 'Esta é a oferta para usuários do plano {type}.',
    tabPayScheme: {
            perMonth: 'Pagamento mensal',
            perYear: 'Pagamento anual',
            perNextYear: 'para o primeiro ano (renova-se a {price})',
            refundDays: 'Dias de garantia de devolução do dinheiro',
            advanced: 'Recursos avançados',
            payPremium: 'Atualizar para qualquer plano premium e usar todos os recursos avançados abaixo',
            payUnlimited: 'Atualizar para qualquer plano ilimitado e usar todos os recursos avançados abaixo',
            freeTip1: 'Mais tráfego de dados de nuvem a nuvem',
            freeTip2: 'Tráfego de dados ilimitado de nuvem a nuvem',
            freeTip3: 'Transferência/sincronização/backup programada',
            freeTip4: 'Sincronização dupla',
            freeTip5: '10 fios de transferência',
            freeTip6: '8 modos de sincronização',
            freeTip7: 'Filtro de arquivo',
            freeTip8: 'Servidor de transferência VIP',
            freeTip9: 'Suporte ao cliente VIP',
            freeTip10: '5 tarefas em paralelo de nuvem a nuvem',
            freeTip11: 'Conversões de e-mail ilimitadas',
            freeTipTitle1: 'Os assinantes podem ter 2 tarefas de sincronização em tempo real e 2 tarefas de sincronização normal (4 no total).',
            freeTipTitle2: 'Há 10 fios de transferência para assinantes e 2 fios de transferência para usuários gratuitos.',
            freeTipTitle3: 'Sincronização bidirecional e 7 opções personalizadas em sincronia unidirecional, sincronização espelhada suportada.',
            freeTipTitle4: 'Configurar um filtro para transferir ou sincronizar arquivos com nome de arquivo definido pelo usuário ou certas extensões automaticamente.',
            freeTipTitle5: 'Os assinantes podem executar 5 tarefas nuvem a nuvem em paralelo, enquanto os usuários livres podem executar 1 tarefa de cada vez.',
            freeTipTitle6: 'Os assinantes podem converter um número ilimitado de e-mails em PDFs, enquanto os usuários gratuitos estão limitados a converter 50 e-mails por mês.',
        },
        nowPayScheme: {
            clearInsCountText: 'Mas a cota de download não utilizada para perfis do Instagram será limpa.',
            manageYourPlan: 'Gerenciar sua assinatura',
            price: 'Preço',
            paymentMethon: 'Método de pagamento',
            autoRenewal: 'Renovação automática',
            priceVat: 'Inclui {currency}{vatPrice} IVA ({percent}% em {currency}{netPrice}).',
            defaultPayment: '{method}, xxxxxxxxxxxx{num}.',
            paypalPayment: 'O método de pagamento padrão é o PayPal.',
            changePayment: 'Alterar o método de pagamento',
            activated: 'Próxima data de faturamento {time}',
            deactivated: 'Próxima data de faturamento {time}',
            appleTip: 'Seus atuais {name} foram comprados na Apple Store.',
            appleTipId: 'ID da Apple Transaction: {id}.',
            googleTip: 'Seus atuais {name} foram comprados no Google Play.',
            googleTipId: 'Google Play ID do pedido: {id}.',
            appNextTimeTip: 'Auto-renovação é ativada. A próxima data de faturamento será {time}.',
            appNoSubscribe: 'Auto-renovação é desativada.',
        },
        // 免费用户弹窗
        freePlanPopup: {
            title_traffic: 'Ops! Tráfego cloud-to-cloud insuficiente',
            title_ins: 'Você atingiu o limite de downloads',
            title_pdf: 'Você atingiu o limite de conversão de e-mail para PDF',
            title_modes: 'O modo é exclusivo dos planos Premium',
            title_remote: 'Você atingiu o limite de upload remoto',
            title_subtasks: 'Você atingiu o limite para a transferência de equipe',
            title_scheduled: 'A função de agendamento é exclusiva para planos premium',
            title_speed: 'Velocidade de transferência quíntupla exclusiva para premium',
            title_sync: 'Você atingiu o limite para a sincronização normal',
            title_real: 'Você atingiu o limite para a sincronização em tempo real',
            title_filter: 'Filtro de arquivos é exclusivo para planos Premium',
            desc: 'Faça upgrade para desbloquear TODOS os recursos avançados',
            itemTitle_th: 'Recursos e Benefícios',
            itemTitle_traffic: 'Tráfego de Nuvem para Nuvem',
            itemTitle_ins: 'Perfis do Instagram para download',
            itemTitle_pdf: 'Converter e-mail para PDF',
            itemTitle_modes: 'Modos de sincronização',
            itemTitle_remote: 'Tarefas de upload remoto em paralelo',
            itemTitle_subtasks: 'Migrar subcontas entre equipes',
            itemTitle_scheduled: 'Transferência/Sincronização/Backup programado',
            itemTitle_speed: 'Velocidade de transferência',
            itemTitle_sync: 'Tarefas de sincronização normais em paralelo',
            itemTitle_real: 'Tarefas de sincronização em tempo real em paralelo',
            itemTitle_filter: 'Filtro de arquivos',
            itemTitle_tran: 'Servidor de transferência VIP',
            itemTitle_customer: 'Suporte ao cliente VIP',
            itemTitle_watermark: 'Remover marca d\'água de e-mails em PDF',
            itemValue_cur: 'Seu plano atual',
            itemValue_free: 'gratuito',
            itemValue_upgrade: 'Atualizar para',
            itemvalue_premium: 'Premium',
            itemvalue_5gb: '5 GB / Mês',
            itemvalue_1profile: '1 Perfil / Mês',
            itemvalue_50emails: '50 E-mails / Mês',
            itemvalue_maxUnlimited: 'Máximo Ilimitado',
            itemvalue_unlimited: 'Ilimitado',
            button: 'Upgrade a partir de R$ 51',
        },
        // 套餐的支持项
        supportItem: {
            yourCurPlan: 'Seu plano atual',
            // 第1组
            gb5: '5GB de tráfego livre de dados por mês',
            gb100: '100GB de tráfego de dados por mês',
            gb200: '200GB de tráfego de dados por mês',
            gb1200: '1200GB de tráfego de dados por ano',
            gb2400: '2400GB de tráfego de dados por ano',
            gbUnlimitedYear: 'Tráfego de dados ilimitado por ano',
            gbUnlimitedLifetime: 'Tráfego de dados ilimitado durante uma vida inteira',
            gbPackage50: '',
            gbPackage100: '',
            gbGiveAway500: '',
            gbGiveAway200: '',
            ins1: '1 perfil Ins para baixar por mês',
            ins10: '10 perfis Ins para baixar por mês',
            ins20: '20 perfis Ins para baixar por mês',
            ins120: '120 perfis Ins para baixar por ano',
            ins240: '240 perfis Ins para baixar por ano',
            insPackage50: '',
            insPackage100: '',
            insGiveAway500: '',
            insGiveAway200: '',
            pdf50: 'Converta 50 e-mails por mês',
            pdfUnlimited: 'Conversões ilimitadas de e-mails',
            threads2: '2 fios para transferência de dados',
            threads10: '10 fios para transferência de dados',
            scheduled: 'Transferência/sync/backup programada',
            // 第2组
            acrossClouds: 'Transferência/sync/backup através das nuvens',
            offline: 'Transferência/sync/backup off-line',
            subAccounts3: 'Migrar 3 sub-contas entre equipas',
            subAccounts1000: 'Migrar 1000 sub-contas entre equipas',
            highSpeed: 'Transferência de dados a alta velocidade',
            // 第3组
            syncMode4: '4 modos de sincronização unidireccional/ bidireccional',
            syncMode10: '10 modos de sincronização unidireccional/ bidireccional',
            realSync: 'Sincronização em tempo real',
            passwordProtected: 'Partilha protegida por palavra-passe',
            subAccounts: 'Colaboração em sub-contas',
            // 第4组
            cloud30: 'Mais de 30 serviços líderes de armazenamento em nuvem',
            unlimitedCloud: 'Adicionar contas de nuvem ilimitadas',
            singleLog: 'Log in único para todas as nuvens',
            support365: '24/7/365 apoio prioritário',
            // 其他
            unlimitedDataTraffic: 'Tráfego de dados ilimitado entre nuvens',
            unlimitedInsProfile: 'Downloads ilimitados de perfis do Ins',
            unlimitedAllFeatures: 'Todos os recursos premium',
            // VIP弹窗标题
            vipPopupTitleTraffic: 'Você consumiu todo o tráfego de dados',
            vipPopupDescTraffic: 'Faça upgrade para desbloquear tráfego de dados ilimitado',
            vipPopupTitleIns: 'Você consumiu todos os downloads de perfis do Instagram',
            vipPopupDescIns: 'Faça upgrade para desbloquear downloads ilimitados de perfis do Instagram',
        },
        //套餐arguments参数翻译
        arguments: {
            //参数名
            title: {
                monthly100GB: '100GB / mês',
                monthly200GB: '200GB / mês',
                monthlyUnlimit: 'Dados ilimitados / mês',
                yearly1200GB: '1200GB / ano',
                yearly2400GB: '2400GB / ano',
                yearlyUnlimit: 'Ilimitado anualmente',
                lifetimeUnlimit: 'Ilimitado por toda vida',
                package50GB: '50 GB',
                package100GB: '100 GB',
                giveAway500GB: '500GB',
                giveAway200GB: '200GB',
            },
            tips: {
                monthly100GB: 'Por exemplo, só consumiu 50GB de 100GB no primeiro mês e ainda terá 50GB de tráfego de dados adicionais no mês seguinte.',
                monthly200GB: 'Por exemplo, só consumiu 150GB de 200GB no primeiro mês e ainda terá 50GB de tráfego de dados adicionais no mês seguinte.',
                monthlyUnlimit: '',
                yearly1200GB: 'Por exemplo, só consumiu 1000GB de 1200GB no primeiro ano e ainda terá 200GB de tráfego de dados adicionais no próximo ano.',
                yearly2400GB: 'Por exemplo, só consumiu 2000GB de 2400GB no primeiro ano e ainda terá 400GB de tráfego de dados adicionais no próximo ano.',
                yearlyUnlimit: '',
                lifetimeUnlimit: '',
                package50GB: 'Por exemplo, só consumiu 20GB de 50GB este mês, os 30GB não utilizados ainda permanecerão no próximo mês',
                package100GB: 'Por exemplo, consumiu apenas 20GB de 100GB este mês, os 80GB não utilizados ainda permanecerão no próximo mês',
            }
        },
    },
    twoStepverification: {
        bind: 'Bind Email First',
        addVerify: 'Você deve adicionar uma forma de verificar.',
        phoneNotEmpty: 'o número de telefone não pode estar vazio.',
        addPhone: 'Adicionar um número de telefone',
        addAlEmail: 'Adicionar endereço de e-mail alternativo',
        verifySet: 'Configuração de verificação',
        addWayVerify: 'Adicionar uma forma de verificar',
        enterEmail: 'Digite seu e-mail',
        enterPhone: 'Digite seu número de telefone',
        enterCode: 'Por favor, digite o código que enviamos para',
        enterCodeTip:'Por favor, verifique sua pasta de lixo eletrônico e não informe spam ou adicione “no-reply@multcloud.email” à sua Lista Branca.',
        codeExpired: 'O código de verificação expirou.',
        codeinCorrect: 'O código de verificação está incorreto, verifique o código e tente novamente.',
        verificationTurnOn: 'A verificação em duas etapas está ativada',
        recoverAccess: 'Se você precisar recuperar o acesso à sua conta, este código ajudará. Você deve anotá-lo e armazená-lo em um local seguro. Recomendamos enfaticamente que você não armazene seu código de recuperação em um dispositivo.' ,
        longValid: 'Se você já tinha um código de recuperação, ele não é mais válido. Use este novo código.',
        removeAll: 'Remova todos os dispositivos?',
        lostAccess: 'Recomendamos que você faça isso se tiver perdido o acesso a um dispositivo em que confiava.',
        removeMethod: 'Remover método de verificação?',
        removeMethodSure: 'Tem certeza de que deseja remover o método de verificação? Removê-lo significa que você não poderá usá-lo para verificação.',
        getRecode: 'Gere um novo código',
        emailCode: 'Enviar um código por e-mail',
        TextCode: 'Text a code',
        useAccount: 'Agora você está usando uma conta temporária, vincule o e-mail e tente novamente.',
        removeTrusted:'Remova todos os dispositivos confiáveis',
        finish:'Concluir',
        newCode:'Seu novo código é',
        twoStep:'Verificação em duas etapas',
        twoStepis:'A verificação em duas etapas é',
        on:'Ativado',
        off:'Desativado',
        cancel:'Cancelar',
        toManyCodeSend:'códigos demasiados enviados',
        verifyIdenti:'Verifique a identidade com',
        codeCopied:'código copiado!',
        copyCode:'copiar o código',
        trustedDevice:'Dispositivos de confiança removidos!',
        phoneValueTips:'Dicas: Remova o zero à esquerda e remova quaisquer espaços, travessões ou parênteses.',
    },
    cloudBackup:{
        cloudBackup:'Backup de nuvem',
        setUpCloud:'Fazer uma tarefa de cópia de nuvem para copiar os ficheiros online de uma nuvem para outra.',
        filesBckupTarget: 'Diretórios de destino',
    filesBckup:'DE',
        selectSoure:'Clique aqui para seleccionar a origem dos ficheiros de nuvem que pretende copiar.',
        saveBackup:'PARA',
        selectTarget:'Clique aqui para seleccionar a nuvem de destino para salvar o backup.',
        backupNow:'Backup imediatamente',
        canSelect:'Pode seleccionar 10000 itens no máximo',
        backupFiles:'Não pode copiar os seus ficheiros para Google Photos',
        notSelectEvernoteBackup: 'Você não pode fazer backup de seus arquivos no Evernote.',
      backFlickr:'Você não pode fazer backup de seus arquivos no Flickr',
        thankSubscrib:'Obrigado por subscrever o nosso serviço. Agora pode copiar 10 ficheiros no máximo em simultâneo.',
        maximunBack:'Pode copiar 2 ficheiros no máximo em simultâneo. Actualize para qualquer serviço para copiar um máximo de 10!',
        backSuccess:'Copiar com sucesso',
        backFailure:'Falha de copiar',
        successBck:'Copiar todos os ficheiros com sucesso',
        taskCanceled:' A tarefa foi cancelada manualmente',
        notRestore:'Não se encontram os ficheiros para salvar. Talvez foram apagados.',
        selectVersions:'Seleccione as versões',
        restoreOptions:'Recupere as opções',
        selectFiles:'Seleccione os ficheiros que pretende recuperar.',
        toRestore:'Seleccione um ficheiro para recuperar, por favor.',
        originalLocation:'Local original',
        thankRestore:'Obrigado por subscrever o nosso serviço. Agora pode recuperar 10 ficheiros no máximo em simultâneo.',
        restoreSimult:'Agora pode recuperar 2 ficheiros no máximo em simultâneo. Actualize para qualquer serviço para recuperar um máximo de 10!',
        restoreSuccess:'Recuperar com sucesso',
        restorePartial:'Recuperar com sucesso parcialmente',
        restoreFailure:'Falha de recuperar',
        notRestore:'Não se encontram os ficheiros para salvar. Talvez foram apagados.',
        backupTime:'Tempo de cópia',
        changedFiles:'Ficheiros alterados',
        deleteVersion:'Está certo de apagar a versão de cópia?',
        deleteFiles:'Apagar os ficheiros nesta versão',
        keepLatest:'Manter sempre o ficheiro mais recente',
        overWriteFile:'Sobregravar o ficheiro',
        skipFile:'Ignorar o ficheiro',
        versions:'Versões',
        backupTask:'Tarefa de Backup',
        readdCloud:'Adicionar nuvem novamente',
        selectedCloud:'Algumas das nuvens seleccionadas foram adicionadas a MultCloud antes do lançamento do Backup de nuvem, sugerimos que adicione as nuvens a MultCloud de novo e tente novamente.',
        continueAnyway:'Continuar de qualquer maneira',
        selectedHasAdded:'A nuvem seleccionada foi adicionada a MultCloud antes do lançamento do Backup de nuvem, sugerimos que adicione a nuvem a MultCloud de novo e tente novamente.',
        failCreate:'Falha na criação de tarefa de backup.',
        failLoad:'Falha no carregamento',
        pleaseReAdd:'Adicione as nuvens a MultCloud de novo.',
        alreadyAdd:'Já adicionou a nuvem.',
        failRename:'Falha na renomeação, porque a pasta correspondente não é encontrada',
        taskRuning:'A tarefa está a decorrer, por favor aguarde até que a tarefa termine e tente novamente.',
        //2021-08-07添加
        oneBackup:'Você só pode executar uma tarefa de backup ou restauração ao mesmo tempo',
        restoreTask:'Tarefa de Restauração',
        restoreOriginal:'Recuperar para o local original',
        restoreNewLocation:'Recuperar para o novo local ',
         //2021-08-12添加
         backingUp:'Fazendo backup',
         restoring:'Restaurando',
         restore:'Restaurar',
         backup:'De',
          //2021-08-17添加
        maxNum:'O número máximo de intem de origem é 1000, selecione menos itens. P.S. Uma pasta inteira conta apenas um item.',
        maxLogs:'Nota: O resultado é truncado. Até 1.000 ficheiros falhados são exibidos aqui.',
        backupDetails:'Detalhes de backup',
        keepTwoFile:'Mantenha dois arquivos',
        restoreDetails:'Detalhes de restauração',
        longerDelete:'Vai custa mais tempo se houver um grande número de arquivos para apagar.',
        notFoundAim:'O diretório de destino não pode ser encontrado.',
        //2021-10-20
        backupNotWork:'O serviço de backup não está funcionando',
        //2021-10-28
        backupPartial:'Sucesso parcial do backup',
        configFile:'(Fazendo upload de arquivo de configuração)',
        successRestore:'Recuperar todos os arquivos com sucesso.',
        notFind:'Não é possível encontrar o arquivo de configuração. Por favor verifique se o arquivo de configuração existe e se a conexão entre nuvem e MultCloud é válida.',
        selectRestoreItems:'Por favor, selecione os arquivos que você deseja restaurar.',
        selectRestoreTotles:'Por favor, selecione um diretório para restaurar.',
        original: 'Original',
        inTotalTip: '{count} arquivos, {size} no total',
    },
    affiliateProgram: {
        leftTitle: "Torne-se nosso afiliado",
        title: "Programa de Afiliados de MultCloud",
        headTips1: "Ganhar até <span>50%</span> de taxa de comissão.",
        headTips2: "Inscreva-se com alguns cliques, absolutamente <span>grátis</span>.",
        headTips3: "Sem condições adicionais, <span>qualquer pessoa</span> pode ser nosso afiliado!",
        signUpBtn: "Inscreva uma conta de afiliado",
        tips: "Dica: Se já é um afiliado em Cleverbridge, por favor, <a href=\"https://console.partnerize.com/campaigns/manage-campaigns/join-campaigns/advertiser-details/1011l331\" target=\"_blank\"> Inscreva-se </a>.",
        howDoTipsTitle: "Como é que funciona",
        howDoTipsMsg: "Uma vez que se inscreva e entra no nosso programa de afiliados, pode encontrar AOMEI International Network Limited sob  \"Campanhas - Aderir à campanha\". Clique nele e confirme a adesão. Assim que adira à nossa campanha, verá que todos os produtos de MultCloud são disponíveis. Se alguém actualizar MultCloud através do seu link de referência, você vai ganhar <span>30%-50%</span> de taxa de comissão.",
        FAQsTitle: "FAQs do programa de afiliados de MultCloud",
        FAQ1: "Como funciona o programa de afiliados?",
        answer1: "Assim que o seu cliente pague através da sua página de referência, receberá o seu pagamento no início do mês seguinte..",
        FAQ2: "Bom, Como é que me inscrevo?",
        answer2: "Pode inscrever-se por clicar em \"Inscrever uma conta de afiliado\" acima. Apenas alguns passos, terá a sua conta de afiliado.",
        answerPs2: "Dica: Assim que assine na consola, pode encontrar a AOMEI International Network Limited sob \"Campains\" tab. Clique  neste e confirme que se associa.",
        FAQ3: "Quanta comissão ganha?",
        answer3: "A comissão difere dos diferentes planos de assinatura. Por exemplo, a taxa de comissão para o plano mensal é de 30%, mas para o plano Life-time Unlimited, é de 50%.",
        FAQ4: "Como obter o meu ganho?",
        answer4: "Depende do \"método de pagamento\" que preencheu. Ganha no início de cada mês.",
        answerPs4: "Dica: Não há limite de número mínimo para cada pagamento.",
        anyQuestionTitle: "Tem alguma pergunta?",
        anyQuestionTip: "Não hesite em contatar com <a href=\"mailto:affiliate@multcloud.com\" class=\"alink\">affiliate@multcloud.com</a>",
    },
    signUp: {
        pwdTip: "Senha (8-16 dígitos)",
        signingUp: "Está fazendo login...",
        tips2: "Ao criar uma conta, você aceita as <a href=\"https://www.multcloud.com/terms\" class=\"alink\">Termos de Serviço<a/>&nbsp;e&nbsp;<a href=\"https://www.multcloud.com/policy\" class=\"alink\">Política de Privacidade<a/>.",
        emailPushTip: "Ao marcar esta caixa, você concorda em receber e-mail de MultCloud sobre produtos, atualizações de serviços, ofertas especiais e eventos. Você pode cancelar sua subscrição a qualquer momento.",
    },
    forgetPwd: {
        title: "Esquece-se da senha?",
        tip: "Digite seu endereço de e-mail e enviaremos-lhe um link para redefinir sua senha.",
        sending: "Está enviando a mensagem...",
        btnTxt: "Enviar e-mail de redefinição",
        tips1: "Esquece-se de endereço de e-mail?",
        tips2: "Envie um e-mail para o suporte",
        tips3: "e vamos rastreá-lo.",
    },
    balackFriday: {
        lastTip: "Não perca este evento!",
        title: "Acesso antecipado Black Friday e Cyber Monday para obter tráfego de dados UNLIMITED nuvem a nuvem com 70% OFF sale!",
        titleTip: "Apresse-se enquanto nosso estoque durar!",
    },
    christmas: {
        payTxt: "Venda de Natal",
        popupTitle: "SUPER-VENDA MULTCLOUD",
        pageTitle: "Obtenha UNLIMITED Cloud-to-Cloud Data Trafiic for Lifetime com {num}% OFF!",
        pageTitle2: "Obtenha Tráfego de Dados UNLIMITED para toda a vida com {num}% de desconto!",
        paysysTitle: "APRESSE-SE, ANTES QUE DESAPAREÇA!",
        popupTip1: "Tráfego de dados de nuvem a nuvem",
        popupTip2: "10 Linhas de transferência de dados em alta velocidade",
        popupTip2Append: "Há 10 fios de transferência para usuários premium e 2 fios de transferência para usuários gratuitos",
        popupTip3: "Transferência programada/Sync/Backup",
        popupTip4: "Sincronização de uma/duas vias em tempo real",
        popupTip4Append: "Há 7 modos de sincronização adicionais para usuários premium. Sincronização espelhada suportada",
        saledBtn: "LOJA AGORA",
    },
    teamTransfer:{
        teamTransfer:'Transferência de equipe',
        transferMultiple:'transferir múltiplas contas de uma plataforma em nuvem para outra (Google Workspace, OneDrive for Business, Dropbox Business, Box for Business, Shared Drive).',
        businessCloud:'Se você é um administrador de nuvens de negócios, você pode usar este recurso para migrar facilmente todas as contas de uma nuvem de negócios para outra. Por exemplo, cada usuário terá uma pasta própria em uma plataforma de nuvem, MultCloud pode automaticamente corresponder às pastas de duas nuvens de negócios diferentes e migrar os arquivos de uma nuvem para outra.',
        clickSelect:'Clique aqui para selecionar os serviços da nuvem de negócios de origem que você gostaria de transferir.',
        sourceAccount:'Contas de origem',
        targetAccounts:'Contas de destino',
        autoMatch:'Correspondência automática',
        likeTransfer:'Clique aqui para selecionar os serviços de nuvem de negócios para os quais você gostaria de transferir.',
        youMust:'Você deve',
        cloudService:' adicionar um serviço de nuvem de negócios ',
        asAdmin:'como administrador em primeiro lugar.',
        combinations:'Correspondência automática irá limpar as combinações atuais, você tem certeza de continuar?',
        nosourceAccount:'Não há conta de origem ou conta de destino.',
        noAccount:'Não há contas para correspondência automática.',
        uploadCSV:'Upload de CSV',
        cleanCurrent :'Upload de CSV vai limpar as combinações atuais, você tem certeza de que continua?',
        csvFile:'O arquivo CSV que você envia deve corresponder ',
        csvFormat:'ao formato .CSV.',
        matchCsv:'A organização não pode corresponder a nenhuma combinação do arquivo CSV, por favor, verifique o arquivo CSV e tente novamente.',
        alreadyAdd:'Você já adicionou a combinação destas duas contas.',
        cleanAll:'Você vai limpar todas as combinações selecionadas, tem certeza de que vai continuar?',
        sure:'Sim, tenho certeza',
        allTransferred:'Manter todos os arquivos transferidos em uma pasta.',
        newTrans:'Iniciar transmissão quando a travessia começar.',
        optionActivated:'Se esta opção for ativada, todos os arquivos transferidos serão mantidos em uma pasta da nuvem de destino. Por exemplo, o diretório de origem é Google Workspace\\simon@multcloud.com, e o diretório de destino é OneDrive for Business\\peter@multcloud.com, todos os arquivos no Google Workspace\\simon@multcloud.com serão transferidos para OneDrive for Business\\peter@multcloud.com\\simon@multcloud.com quando esta opção for ativada.',
        newTransTip: 'Tarefas suportadas: 1. A origem deve ser uma pasta 2. A origem é um disco na nuvem, não um e-mail 3. O destino não é um disco na nuvem baseado em fotos',
        organizationMigration:'Migração da organização',
        //jimin新增
        downloadCSV:'Baixar CSV',
        dontShow:'Não mostre isso de novo',
        notSelected:'Drive compartilhado do Google Workspace não pode ser selecionado como a nuvem de destino para a migração da equipe.',
        batchMatch:'Correspondência a granel',
        sourceCloud:'Adicionar nuvem de origem',
        targetCloud:'Adicionar nuvem de destino',
        subTaskLimit:'Limite da subtarefa',
        freeUsers:'Usuários gratuitos podem criar 3 subtarefas em uma tarefa de transferência de equipe. Por favor atualize para a versão premium e você pode ter 1000 subtarefas em uma tarefa de transferência de equipe.',
        mostTeamTransfer:'3 subtareas en una transferencia de equipo',
        substasksMost:'1000 subtarefas em uma transferência de equipe',
        mostTasks:'O número de subtarefas pode ser de no máximo 1000.',
        timePassed:'O tempo definido expirou.',
    } ,
    shareTransfers: {
        logoMsg: '<span class="sf-logo-name">Transferência de </span><span class="sf-logo-first">MultCloud</span>',
        addFiles: 'Adicionar arquivos das nuvens',
        trnsfering: 'Está transferindo..',
        sendingFile: 'Enviar {num} arquivo(s)',
        sendingSize: '{num}/{all}',
        sendingTip: 'O link de transferência está sendo criado, aguarde, por favor.',
        cancelTransfer: 'Cancelar esta transferência？',
        createdTransfer: ' Transferência é criada！',
        createShare: 'Criar Transferência',
        signTitleByTransfer: 'Entre em Multcloud para continuar',
        signupTitleByTransfer: 'Inscreva-se em Multcloud para continuar',
        transferTitle: 'Títuloo',
        transferDescription: 'Descrição',
        addFileTip: '{num} arquivo(s) foram adicionados',
        titleErrMsg: 'O título não deve ultrapassar 128 caracteres',
        desErrMsg: 'A descrição não pode ultrapassar 512 caracteres',
        folder: 'Pasta',
    },
    summerSale: {
        titleTip: 'Olá verão',
        titleTip2: 'Obtenha tráfego de dados nuvem a nuvem ILIMITADO e gerencie todas as suas memórias de verão sem esforço por um preço acessível!',
        bottomTip: '- MELHOR OFERTA DA TEMPORADA –',
    },
    halloweenSale: {
        titleTip2: 'Sem truques, trate de tráfego ilimitado de dados em nuvens cruzadas e economize até 70%! ',
        bottomTip: 'Rápido! A campanha termina em breve',
    },
    newYear: {
        payTxt: "VENDA DO ANO NOVO",
        titleTip: 'Entregue o Ano Novo com um super desconto de 70% no tráfego de dados ilimitado de nuvem para nuvem!',
        bottomTip: 'Depressa! Antes que desapareça.',
    },
    backToSchool: {
        titleTip2: 'Obtenha tráfego de dados nuvem a nuvem ILIMITADO e gerencie todas as suas memórias escolares por um ótimo preço!',
        bottomTip: '- MELHOR OFERTA DA TEMPORADA –',
    },
    blackFriday: {
        titleTip: 'Obtenha 70% de desconto no tráfego de dados nuvem a nuvem ILIMITADO.',
        bottomTip: 'Depressa! Antes que desapareça.',
    },
    xmas: {
        titleTip: 'Desfrute de um desconto festivo de 70% no tráfego de dados nuvem a nuvem ILIMITADO neste Natal!',
        bottomTip: 'Depressa! Antes que desapareça.',
    },
    license: {
        codeTitle: 'Inserir licença',
        codeTipTitle: 'Inserir Código de Licença',
        codeTipText: 'Se você tem um código de licença, pode usá-lo para ativar o serviço premium.',
        codeTipTextVip: 'Se você possui um código de licença, pode utilizá-lo para atualizar para um serviço mais avançado.',
        codeFooter: 'Se precisar de alguma ajuda, fique à vontade para entrar em contato: ',
        showTitle: 'Código de licença',
        showTip: 'O código de licença é:',
        codeSucTitle: 'Serviço Premium ativado',
        codeSucTip: 'Serviço Premium ativado!',
    },
    filters: {
        taskList: {
            typeName: 'type',
            type: {
                all: 'Lista completa',
                copy: 'Tarefas temp',
                transfer: 'Transferência na nuvem',
                sync: 'Sincronização na nuvem',
                backup: 'Backup na nuvem',
                business: 'Transferência de equipe',
                remoteUpload: 'Upload remoto',
                emailMigration: 'Migração de e-mail',
            },
            statusName: "Status",
            status: {
                all: "Todos os Status",
                preset: 'Predefinição',
                running: 'Em execução',
                success: 'Sucesso',
                patial: 'Sucesso parcial',
                failed: 'Falha',
                canceled: 'Cancelado',
            },
            dateName: "Date",
            date: {
                all: 'Todo o período',
                today: 'Hoje',
                latestWeek: 'Última semana',
                latestMonth: 'Último mês',
                customDate: 'Data personalizada',
            },
        }
    },
    schedule: {
        week1: "Domingo",
        week2: "Segunda-feira",
        week3: "Terça-feira",
        week4: "Quarta-feira",
        week5: "Quinta-feira",
        week6: "Sexta-feira",
        week7: "Sábado",
    },
    inputTab: {
        filterMessage: 'Pressione Enter para adicionar a extensão do arquivo',
    }
}


// WEBPACK FOOTER //
// ./src/assets/i18n/portuguese.js